export default {
    address: {
        city: "Grad",
        city_locality: "Grad \/ Mesto",
        country: "Zemlja",
        line1: "Adresa, red 1",
        line2: "Adresa, red 2",
        postal_code: "Poštanski broj",
        state: "Država",
        state_region: "Država \/ Region"
    },
    alerts: {
        account_2fa: "Obezbedite svoj nalog dvofaktorskom autentifikacijom.",
        account_2fa_success: "Dvofaktorska autentifikacija je omogućena.",
        activate_instruction: "Uključivanje automatskog prikupljanja recenzija će pokušati da zatraži recenziju od {count}. Pregledajte svoje šablone pre omogućavanja.",
        activate_intro: "Kontinuirano zahtevajte Recenzije na osnovu vaše strategije.",
        agency_mcp_server: "Povežite Kloda ili bilo kog MCP klijenta sa MCP server vaše agencije. Ovlašćeni asistenti mogu da upravljaju projektima, klijentima i timom vaše agencije u vaše ime.",
        agency_sso: "Повежите добављача идентитета OpenID Connect за пријаву клијента.",
        ai_assistant: "Naziv i opis vašeg preduzeća su obavezni da bi se koristila veštačka inteligencija za predloge recenzija i odgovore.",
        api_key_roll: "Da li ste sigurni da želite da promenite svoj API ključ? Ovo će uticati na sve aplikacije koje ga koriste.",
        ask_confirm: "Da li ste sigurni da želite da zatražite recenzije od {count}? Ovo će zakazati zahteve za sve klijente koji još nisu zamoljeni.",
        cname_delete: "Da li ste sigurni da želite da uklonite CNAME: {cname_name}?",
        cname_not_configured: "Ovaj zapis još nije konfigurisan. Molimo sačekajte...",
        cname_warning: "Poruke koje su već poslate vašim klijentima imaće neispravne linkove.",
        connection_disabled: "Veza je onemogućena. Molimo vas da se ponovo povežete.",
        customer_archive: "Da li ste sigurni da želite da arhivirate korisnika: {customer_name}? Sve neposlate poruke će biti otkazane.",
        customer_cancel: "Da li ste sigurni da želite da otkažete sve neposlate poruke za korisnika: {customer_name}?",
        customer_ingest: "Uključite ovu adresu e-pošte u polje BCC kada šaljete e-poštu svojim klijentima kako bi se njihovo ime i adresa e-pošte automatski uvezli.",
        customer_resubscribe: "Da li ste sigurni da želite ponovo da pretplatite kupca: {customer_name}?",
        customer_unarchive: "Da li ste sigurni da želite da vratite iz arhive kupca: {customer_name}?",
        customer_unsubscribe: "Da li ste sigurni da želite da odjavite korisnika: {customer_name}?",
        customer_unsubscribe_all: "Da li ste sigurni da želite da se odjavite sa {count} od primanja poruka sa ovog projekta?",
        delete: "Da li ste sigurni da želite da obrišete {model}: {name}?",
        delete_count: "Da li ste sigurni da želite da obrišete {count}",
        domain_agency: "Dodajte sopstveni domen za slanje da biste potpuno „white label“-ovali svoju agenciju.",
        domain_delete: "Da li ste sigurni da želite da uklonite domen: {name}? Nastavićemo da šaljemo imejlove sa našeg sopstvenog domena.",
        domain_dmarc: "Dodajte DMARC zapis svom domenu da biste smanjili šansu da imejlovi završi u spamu.",
        domain_project: "Dodajte domen za slanje kako bismo mogli da šaljemo imejlove vašim klijentima sa vašeg sopstvenog domena.",
        export_confirm: "Da li ste sigurni da želite da izvezete sve svoje {model}?",
        export_count: "Da li ste sigurni da želite da izvezete {count}?",
        export_link: "Link za preuzimanje će biti poslat na {email} ubrzo nakon što podnesete zahtev.",
        highlights_save_disabled: "Opciono možete ukloniti istaknute delove iz svih recenzije koje ih trenutno sadrže.",
        highlights_save_enabled: "Da biste generisali istaknute delove za sve pozitivne recenzije, označite polje ispod. Ako menjate samo boju isticanja, ostavite polje neoznačeno.",
        integration_disconnect: "Da li ste sigurni da želite da se isključite sa {integration_name}?",
        integration_sync: "Da li ste sigurni da želite da sinhronizujete svoj {integration_name} nalog? Kontinuirano ćemo uvoziti vaše podatke.",
        intro: "Spremni ste da dobijete još dobrih recenzije od svojih kupaca? Uvezite svoje kupce da biste započeli. Zatim ručno zatražite recenzije ili pritisnite dugme „Automatizuj“ i pustite da recenzije pristižu.",
        logout: "Da li ste sigurni da želite da se odjavite?",
        mcp_server: "Povežite Kloda ili bilo kog MCP klijenta sa ovim projektom. MCP server omogućava AI asistentima da čitaju i upravljaju recenzije, kupcima i porukama u vaše ime.",
        member_confirm: "Da li ste sigurni da želite da uklonite sebe? Izgubićete pristup ovom projektu.",
        member_confirm_all: "Da li ste sigurni da želite da uklonite sebe? Izgubićete pristup svim svojim projektima.",
        member_other_confirm: "Da li ste sigurni da želite da uklonite {noun}: {name}? Izgubiće pristup ovom projektu.",
        member_other_confirm_all: "Da li ste sigurni da želite da uklonite {noun} {name}? Izgubiće pristup svim svojim projektima.",
        message_cancel: "Da li ste sigurni da želite da otkažete ovu poruku?",
        message_cancel_all: "Da li ste sigurni da želite da otkažete {count}? Ova radnja se može izvršiti samo na neposlatim porukama.",
        message_delete: "Da li ste sigurni da želite da obrišete ovu poruku?",
        oauth_client_revoke: "Da li ste sigurni da želite da opozovete pristup za {client}? Sve aktivne sesije će biti odmah prekinute.",
        project_summary: "Trenutno nije moguće generisati rezime.",
        project_suspend: "Da li ste sigurni da želite da obustavite projekat: {project_name}?",
        project_unsuspend: "Da li ste sigurni da želite da ponovo aktivirate projekat: {project_name}?",
        review_delete: "Da li ste sigurni da želite da obrišete ovu recenziju? Ova radnja se ne može poništiti.",
        review_page_confirm: "Da li ste sigurni da želite da sačuvaj izmene?",
        review_page_confirmation: "Prikažite poruku potvrde na stranici uspeha na osnovu izabrane ocene.",
        review_page_default: "Da li ste sigurni da želite da Stranica za recenziju: {name} bude vaša podrazumevana stranica? Ova stranica će se koristiti ako zahtevu za Recenzija nije dodeljena nijedna druga stranica.",
        review_page_delete: "Da li ste sigurni da želite da obrišete stranicu za recenzije: {name}? Svi korisnici koji su trenutno usmereni na ovu stranicu biće usmereni na vašu podrazumevanu stranicu.",
        review_page_delete_all: "Da li ste sigurni da želite da obrišete {count}? Vaša podrazumevana stranica za recenziju neće biti obrisana.",
        review_page_fields: "Koristite polja za prikupljanje podataka o kupcima kada ostavljaju recenziju. Dodajte još polja u obrazac i uslovno ih prikažite kada kupci izaberu ocenu.",
        review_page_instructions: "Prikaži uputstva direktno iznad obrasca nakon što je ocena izabrana.",
        review_page_location_picker: "Dozvolite kupcima da izaberu bilo koju lokaciju u vašem projektu za Recenzija. Ovo će biti unapred izabrano ako je Stranica za recenziju namenjena za prikazivanje za određenu lokaciju.",
        review_page_locations: "Izaberite lokacije koje treba da koriste ovu Stranica za recenziju. Lokacija može biti dodeljena samo jednoj stranici za Recenzija. Ako lokaciji nije dodeljena jedna, koristiće se podrazumevana Stranica za recenziju.",
        review_page_redirects: "Preskočite obrazac nakon što je ocena izabrana i preusmerite na drugo mesto. Takođe možete podeliti saobraćaj na više veb lokacija dodavanjem više od jednog preusmeravanja za svaku ocenu.",
        share_template_delete: "Da li ste sigurni da želite da obrišete šablon za deljenje „{name}“? Ova radnja se ne može poništiti.",
        smtp_remove: "Da li ste sigurni da želite da uklonite SMTP konfiguraciju iz vašeg projekta? Vaš domen za slanje će se vratiti na standardnu konfiguraciju.",
        smtp_setup: "Šaljite imejlove sa svog poštanskog servera. Unesite svoje SMTP akreditive. Ako vaš server koristi IP ograničenja, dodajte sledeće IP adrese na belu listu koje koristi naš sistem: {ips}.",
        space_delete: "Da li ste sigurni da želite da obrišete radni prostor: {name}? Svi projekti unutar njega biće obrisani.",
        tag_rule: "Dodajte pozitivan termin i njegov negativni ekvivalent. Ako je primenljivo, koristićemo veštačku inteligenciju da automatski označimo recenziju jednim ili drugim.",
        user_delete: "Da li ste sigurni da želite da obrišete korisnički nalog za: {email}?",
        user_verify: "Da biste potvrdili svoju adresu e-pošte i aktivirali nalog, kliknite na vezu u e-pošti poslatoj na: {email}.",
        widget_delete: "Da li ste sigurni da želite da obrišete vidžet: {name}? Vidžet se više neće prikazivati ni na jednoj veb stranici.",
        widget_restore: "Da li ste sigurni da želite da vratite podešavanja za vidžet: {name}? Samo će se dizajn vratiti na podrazumevane vrednosti.",
        widgets_1: "Dodajte ovu skriptu u telo vaše veb stranice.",
        widgets_2: "Zid recenzija prikazuje sve vaše recenzije u vidu mreže. Dodajte ovu skriptu tamo gde želite da se vidžet prikazuje.",
        widgets_3: "Istaknuta recenzija prikazuje jednu veliku recenziju. Dodajte ovu skriptu tamo gde želite da se vidžet prikazuje."
    },
    billing_statuses: {
        active: "Vaša pretplata je aktivna.",
        canceled: "Vaša pretplata je otkazana. Nadogradite da biste nastavili.",
        ending: "Ваша претплата истиче {date}.",
        trial: "Vaš besplatni probni period se završava {date}.",
        trial_expired: "Vaš besplatni probni period je završen. Nadogradite da biste nastavili.",
        trial_expiring: "Vaš besplatni probni period uskoro ističe. Nadogradite da biste nastavili."
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "E-pošta",
        facebook: "Fejsbuk",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Mesindžer",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Redit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Niti",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "Dodajte domen za slanje da biste izmenili adresu e-pošte:",
        agency_robots: "Dozvolite pretraživačima da indeksiraju vaš korisnički portal.",
        ai_business_description: "Detaljan opis vašeg poslovanja koji će vam pomoći u generisanju predloga za recenzije i odgovora.",
        ai_business_name: "Naziv vašeg preduzeća.",
        ask_location: "Lokacija koju treba dodeliti recenziji.",
        ask_review_page: "Stranica za beleženje recenzije.",
        assign_tags: "Dodelite tegovi recenziji.",
        csv_max_rows: "Do {count} redova",
        dashboard_configure_settings: "Konfigurišite podešavanja projekta.",
        dashboard_import_customers: "Uvezite svoje kupce.",
        dashboard_preview_email_templates: "Pregledajte svoje šablone e-pošte.",
        dashboard_preview_kiosk_page: "Pregledajte stranicu vašeg kioska.",
        dashboard_preview_review_page: "Pregledajte stranicu za recenzije.",
        dashboard_preview_showcase_page: "Pregledajte svoju stranicu za prezentaciju.",
        logo_height: "Visina logotipa na imejlovima i stranicama.",
        meta_description: "Zamenite opis stranice.",
        meta_title: "Zamenite naslov stranice.",
        mfa_password: "Unesite lozinku za svoj nalog.",
        mfa_qr_code: "Skenirajte QR kod pomoću aplikacije za autentifikaciju.",
        mfa_security_code: "Unesite kod iz aplikacije za autentifikaciju.",
        override_ambassador: "Prikažite značku na imejlovima, stranicama i vidžetima vaših klijenata.",
        project_name: "Naziv vašeg preduzeća, brenda ili veb-sajta.",
        project_robots: "Dozvolite pretraživačima da indeksiraju vaše stranice sa recenzijama i prikažu ih.",
        project_slug: "Koristi se u imejlovima i linkovima okrenutim kupcima ako CNAME nije konfigurisan.",
        review_page_copied_message: "Prikazuje se nakon što je poslata pozitivna recenzija.",
        review_page_email_address: "Primajte recenzije na ovu imejl adresu.",
        review_page_link_reveal_position: "Gde otkriti linkove.",
        review_page_link_revealer_label: "Oznaka za otkrivanje linkova.",
        review_page_link_revealer_rating: "Prikaži linkove ako kupac izabere ovu ili višu ocenu, u suprotnom prikaži dugme za njihovo otkrivanje.",
        review_page_native_reviews: "Dozvoli recenzije na ovoj platformi.",
        review_page_rating_selection: "Sačuvaj ocenu pre nego što pošaljete recenziju.",
        review_page_success_button_link: "Ako je prazno, podrazumevana veza je ka veb-sajtu vašeg projekta, u suprotnom domenu stranice.",
        review_page_warning: "Sprečavanje kupaca da ostavljaju javne recenzije može dovesti do uklanjanja vašeg poslovnog profila.",
        review_reply_status: "Ne možemo javno odgovoriti na ovu recenziju. Umesto toga, možete direktno kontaktirati recenzenta.",
        review_suggestions: "Pomozite kupcima da napišu recenzije.",
        separate_with_commas: "Odvojite višestruke brojeve zarezima.",
        setup_basics: "Подесите када и како тражите рецензије од купаца.",
        setup_business: "Реците нам име по којем вас купци познају.",
        setup_google: "Шаљите купце на свој Google профил, одговарајте на recenzije и увозите постојеће. Ово можете прескочити и урадити касније.",
        setup_location_limit: "Ваша пробна верзија укључује 1 локацију. Надоградите било када да бисте синхронизовали више.",
        showcase_locations: "Ograničite izlog na određene lokacije.",
        showcase_review_length: "Recenzije moraju imati najmanje ovoliko znakovi.",
        showcase_since: "Prikaži recenzije kreirane ovog datuma ili pre njega.",
        showcase_sources: "Ograničite prikazivanje na određene izvore.",
        showcase_tags: "Ograničite prikazivanje na recenzije sa određenim tegovi.",
        signature_html: "Kopirajte i nalepite potpis u svoju aplikaciju za e-poštu.",
        signed_up: "Datum početka klijenta.",
        twilio_webhook: "Postavite kao URL za povratni poziv za vašu uslugu razmene poruka.",
        widget_embed: "Atribut ID-a div kontejnera gde će se prikazivati vidžet."
    },
    labels: {
        accept_all: "Prihvati sve",
        access_code: "Pristupni kod",
        access_codes: "Pristupni kodovi",
        account: "Nalog",
        account_sid: "SID naloga",
        action: "Akcija",
        actions: "Akcije",
        activate: "Aktiviraj",
        active: "Aktivno",
        add: "Dodaj",
        add_agency_project: "Dodaj projekat agencije",
        add_confirmation_message: "Dodajte poruku za potvrdu.",
        add_css_rules: "Dodajte svoja CSS pravila.",
        add_custom_field: "Dodaj prilagođeno polje",
        add_customer: "Dodaj kupca",
        add_customers_with: "Dodajte kupce sa {model}",
        add_external_link: "Dodaj eksterni Link",
        add_external_links: "Dodaj eksterne Linkovi",
        add_introduction: "Dodajte uvod.",
        add_js_tags: "Dodajte sopstvene JavaScript tegovi.",
        add_legal_information: "Dodajte pravne informacije.",
        add_location: "Dodaj lokaciju",
        add_project: "Dodaj projekat",
        add_review: "Dodaj Recenzija",
        add_source: "Додај извор",
        add_tag: "Dodaj Teg",
        added: "Dodato",
        address: "Adresa",
        advanced_review_pages: "Stranice za recenzije",
        affiliates: "Partneri",
        age_of_reviews: "Starost Recenzije",
        agencies: "Agencije",
        agency: "Agencija",
        agency_name: "Naziv agencije",
        agency_project: "Projekat agencije",
        agency_projects: "Projekti agencije",
        ai: "Veštačka inteligencija",
        ai_answers: "AI odgovori",
        ai_assistant: "AI asistent",
        ai_auto_tagging: "Automatsko obeležavanje pomoću veštačke inteligencije",
        ai_reviews_and_replies: "Predlozi i odgovori za Recenzija veštačke inteligencije",
        ai_tagging_instructions: "Primer: Primenite na recenzije koje pominju vreme čekanja, sporu uslugu ili kašnjenja.",
        all: "Svi",
        allowed_domains: "Dozvoljeni domeni",
        amount: "Iznos",
        analytics: "Analitika",
        and: "i",
        anonymous_reviews: "Anonimne Recenzije",
        answer: "Odgovor",
        any: "Bilo koji",
        api: "API",
        api_key: "API ključ",
        appearance: "Izgled",
        approved: "Odobreno",
        archive: "Arhiva",
        archive_customer: "Arhiviraj klijenta",
        archived: "Arhivirano",
        at_least: "barem",
        at_least_days: "Najmanje {num} dana",
        at_least_hours: "Najmanje {num} sati",
        at_least_months: "Najmanje {num} meseci",
        at_most: "najviše",
        at_most_days: "Najviše {num} dana",
        at_most_hours: "Najviše {num} sati",
        at_most_months: "Najviše {num} meseci",
        auth_token: "Token za autentifikaciju",
        authorize: "Ovlasti",
        auto_detect: "Automatsko otkrivanje",
        auto_tags: "Automatske tegovi",
        automate: "Automatizuj",
        automate_highlights: "Automatizuj isticanja",
        automate_replies: "Automatizuj odgovore",
        automatic_review_collection: "Automatsko prikupljanje Recenzija",
        automatically_apply_tags: "Automatski primeni teg na postojeće recenzije",
        automating: "Automatizacija",
        avatar: "Avatar",
        avatars: "Avatari",
        average_charge: "Prosečna naplata",
        average_review: "Prosečna Recenzija",
        background_color: "Boja pozadine",
        background_image: "Pozadinska slika",
        back: "Назад",
        bcc: "BCC",
        bcc_email_address: "BCC imejl adresa",
        best_to_worst: "Od najboljeg do najgoreg",
        billing: "Naplata",
        blog: "Blog",
        body: "Sadržaj",
        body_font_size: "Veličina fonta u Sadržaj",
        bold: "Podebljano",
        book_a_demo: "Zakaži demo",
        bottom: "Dno",
        bottom_left: "Dole levo",
        bottom_right: "Dole desno",
        build_on: "Napravite na {model}",
        business: "Business",
        business_description: "Opis poslovanja",
        business_email: "Adresa e-pošte za podršku",
        business_name: "Naziv preduzeća",
        business_phone: "Broj telefona za podršku",
        business_website: "Veb-sajt preduzeća",
        button: "Dugme",
        button_label: "Teg za Dugme",
        button_link: "Link za Dugme",
        button_position: "Položaj Dugme",
        button_size: "Veličina Dugme",
        buy_me_a_coffee: "Kupi mi kafu",
        by: "od strane",
        by_signing_up: "Kreiranjem naloga, prihvatate naše",
        call_to_action: "Poziv na akciju",
        cancel: "Otkaži",
        cancel_1_message: "Otkaži 1 poruku",
        cancel_message: "Otkaži poruku",
        cancel_messages: "Otkaži {count} poruke",
        cancel_subscription: "Otkaži pretplatu",
        cancel_unsent_messages: "Otkaži neposlate poruke",
        canceled: "Otkazano",
        center: "Centar",
        change: "Promena",
        change_key: "Promenite svoj API ključ",
        change_plan: "Promena plana",
        changelog: "Dnevnik promena",
        channel: "Kanal",
        channels: "Kanali",
        characters: "Znakovi",
        charges_avg: "Prosečna naplata mora biti najmanje",
        charges_count: "Broj naplata mora biti najmanje",
        charges_sum: "Ukupni troškovi moraju biti najmanje",
        chat_with_us: "Ćaskajte sa nama",
        checkbox: "Polje za potvrdu",
        claude: "Klod",
        clear: "Jasno",
        clear_highlights_from_reviews: "Ukloni istaknute stavke iz svih recenzije",
        clicked: "Kliknuto",
        client: "Klijent",
        client_id: "Client ID",
        clients: "Klijenti",
        close: "Затвори",
        cloudflare_warning: "Ako koristite Cloudflare, vaš proksi mora biti isključen.",
        cname: "CNAME",
        cname_setup_incomplete: "Подешавање није завршено - биће уклоњено {date}",
        cname_ssl_pending: "Чека се SSL сертификат",
        cname_status_for: "CNAME status za",
        code_editor: "Uređivač koda",
        collapse: "Sklopi",
        collect_reviews_anywhere: "Prikupljajte recenzije bilo gde",
        color: "Boja",
        colors: "Boje",
        commission_rate: "Stopa provizije",
        commission_status_approved: "Odobreno",
        commission_status_paid: "Plaćeno",
        commission_status_pending: "Na čekanju",
        commission_status_reversed: "Obrnuto",
        community: "Zajednica",
        company: "Kompanija",
        complained: "Žalba je podneta",
        confirm_new_password: "Potvrdite novu lozinku",
        confirmation_message: "Poruka potvrde",
        connect: "Poveži se",
        connect_bank: "Poveži bankovni račun",
        connect_google: "Повежи се са Google",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Povezano",
        consent_preferences: "Podešavanja saglasnosti",
        contact_customer: "Kontaktirajte kupca",
        contact_form: "Kontakt formular",
        contact_support: "Molimo kontaktirajte podršku.",
        contact_us: "Kontaktirajte nas",
        container_element: "Element kontejnera",
        context: "Kontekst",
        continue: "Nastavi",
        continue_with_google: "Nastavite sa Google",
        cookie_category_analytics: "Аналитика",
        cookie_category_essential: "Osnovno",
        cookie_category_functional: "Funkcionalno",
        cookie_category_marketing: "Marketing",
        cookie_consent_banner: "Baner za saglasnost za kolačiće",
        cookie_consent_scope_all: "Pokaži svima",
        cookie_consent_scope_eea: "Prikaži samo posetiocima iz EEA i Ujedinjenog Kraljevstva",
        cookie_consent_scope_none: "Ne prikazuj",
        cookie_policy: "Politika kolačića",
        cookie_preference: "Podešavanja kolačića",
        copied: "Kopirano",
        copied_message: "Kopirana poruka",
        copy: "Kopija",
        copy_embed_code: "Kopiraj kod za ugradnju",
        copy_signature: "Kopija Potpis",
        copy_source_code: "Kopirajte izvorni kod",
        copy_to_all_ratings: "Kopiraj u sve ocene",
        copy_uuid: "Kopiraj UUID",
        create: "Kreiraj",
        create_account: "Napravi nalog",
        create_agency: "Kreirajte agenciju",
        create_cname: "Napravite CNAME zapis i usmerite ga ka",
        create_external_link: "Kreirajte eksterni Link",
        create_field: "Kreiraj polje",
        create_link: "Napravi Link",
        create_location: "Kreiraj lokaciju",
        create_project: "Napravi projekat",
        create_qr_code: "Napravi QR kod",
        create_review: "Napravi Recenzija",
        create_review_page: "Napravite Stranica za recenziju",
        create_signature: "Napravite potpis",
        create_source: "Kreiraj izvor",
        create_space: "Napravi Radni prostor",
        create_tag: "Napravi Teg",
        create_tag_rule: "Kreirajte pravilo za Teg",
        create_webhook: "Napravite vebhuk",
        create_widget: "Napravite vidžet",
        crms: "CRMs",
        csv: "CSV",
        currency: "Valuta",
        current_plan: "Trenutni plan",
        current_year: "Tekuća godina",
        custom_field: "Prilagođeno polje",
        custom_instructions: "Prilagođena uputstva",
        custom_url: "Prilagođeni URL",
        customer: "Klijent",
        customer_name_convention: "Konvencija o imenima kupaca",
        customer_reviews: "Recenzije kupaca",
        customers: "Klijenti",
        customize: "Prilagodi",
        customize_review_page: "Prilagodi Stranica za recenziju",
        daily: "Dnevno",
        daily_email_requests: "Dnevni zahtevi za imejl",
        daily_limit: "Dnevni limit",
        daily_requests: "Dnevni zahtevi",
        daily_sms_requests: "Dnevni SMS zahtevi",
        dark: "Tamno",
        dashboard: "Kontrolna tabla",
        date: "Datum",
        date_added: "Datum dodavanja",
        date_canceled: "Datum otkazivanja",
        date_clicked: "Datum klika",
        date_complained: "Datum žalbe",
        date_delivered: "Datum isporuke",
        date_failed: "Datum neuspeha",
        date_messaged: "Datum slanja poruke",
        date_opened: "Datum otvaranja",
        date_replied: "Datum odgovora",
        date_requested: "Datum zahteva",
        date_reviewed: "Datum recenzije",
        date_scheduled: "Zakazan datum",
        date_sent: "Datum slanja",
        date_signed_up: "Datum registracije",
        date_updated: "Datum ažuriranja",
        dates: "Datumi",
        day: "Dan",
        days: "Dani",
        days_after_last_request: "dana nakon poslednjeg zahteva",
        days_later: "dana kasnije",
        deactivate: "Deaktiviraj",
        default: "Podrazumevano",
        default_language: "Podrazumevani jezik",
        default_review_page: "Podrazumevana Stranica za recenziju",
        default_review_visibility: "Podrazumevana vidljivost Recenzija",
        default_tone: "Podrazumevani ton",
        delay: "Kašnjenje",
        delete: "Obriši",
        delete_1_customer: "Obriši 1 kupca",
        delete_1_review: "Obriši 1 Recenzija",
        delete_1_review_page: "Obriši 1 Stranica za recenziju",
        delete_1_widget: "Obriši 1 vidžet",
        delete_agency: "Obriši agenciju",
        delete_custom_field: "Obriši prilagođeno polje",
        delete_customer: "Obriši kupca",
        delete_customers: "Obriši kupce",
        delete_external_link: "Obriši spoljni Link",
        delete_field: "Obriši polje",
        delete_link: "Obriši Link",
        delete_location: "Obriši lokaciju",
        delete_message: "Obriši poruku",
        delete_n_customers: "Obriši {count} korisnike",
        delete_n_review_pages: "Obriši {count} Stranice za recenzije",
        delete_n_reviews: "Obriši {count} Recenzije",
        delete_n_widgets: "Obriši {count} vidžete",
        delete_project: "Obriši projekat",
        delete_qr_code: "Obriši QR kod",
        delete_reply: "Obriši odgovor",
        delete_review: "Obriši Recenzija",
        delete_review_page: "Obriši Stranica za recenziju",
        delete_review_pages: "Obriši Stranice za recenzije",
        delete_reviews: "Obriši Recenzije",
        delete_signature: "Obriši Potpis",
        delete_source: "Obriši izvor",
        delete_space: "Obriši Radni prostor",
        delete_tag: "Obriši Teg",
        delete_tag_rule: "Pravilo brisanja Teg",
        delete_template: "Obriši šablon",
        delete_user: "Obriši korisnika",
        delete_webhook: "Obriši vebhuk",
        delete_widget: "Obriši vidžet",
        delete_widgets: "Obriši vidžete",
        deleted: "Izbrisano",
        delivered: "Dostavljeno",
        description: "Opis",
        deselect_all: "Poništi izbor svih",
        disable: "Onemogući",
        disable_automatic_review_collection: "Onemogući automatsko prikupljanje recenzija",
        disable_field: "Onemogući polje",
        disable_when_links_are_visible: "Onemogući kada su linkovi vidljivi",
        disabled: "Onemogućeno",
        disconnect: "Prekini vezu",
        disconnect_integration: "Isključite integraciju",
        discord_community: "Discord zajednica",
        display_name: "Prikazano ime",
        dmarc: "DMARC",
        dmarc_status_for: "DMARC status za",
        do_not_hide_from_public: "Ne krij se od javnosti",
        do_not_send: "Ne šalji",
        docs: "Документи",
        documentation: "Dokumentacija",
        domain: "Domen",
        domain_name: "Ime domena",
        dont_have_an_account: "Nemate nalog?",
        dont_send_thanks: "Ne šaljite zahvalnice",
        download: "Preuzmi",
        download_records: "Preuzmi zapise",
        download_template: "Preuzmi šablon",
        dpa: "Dopuna za zaštitu podataka",
        dsar: "DSAR",
        duplicate: "Duplikat",
        duplicate_project: "Duplirani projekat",
        duplicate_review_page: "Duplirana Stranica za recenziju",
        duplicate_reviews: "Duplirane Recenzije",
        duplicate_widget: "Duplirani vidžet",
        edit: "Izmeni",
        edit_1_customer: "Izmeni 1 kupca",
        edit_1_review: "Izmeni 1 Recenzija",
        edit_client: "Izmeni Klijent",
        edit_custom_field: "Uredi prilagođeno polje",
        edit_customer: "Izmeni kupca",
        edit_customers: "Izmeni korisnike",
        edit_field: "Uredi polje",
        edit_link: "Izmeni Link",
        edit_location: "Izmeni lokaciju",
        edit_member: "Uredi člana",
        edit_n_customers: "Izmeni {count} korisnike",
        edit_n_reviews: "Izmeni {count} Recenzije",
        edit_notes: "Uredi beleške",
        edit_qr_code: "Izmeni QR kod",
        edit_reviews: "Izmeni Recenzije",
        edit_signature: "Izmeni Potpis",
        edit_source: "Izmeni izvor",
        edit_strategy: "Izmeni strategiju",
        edit_tag: "Izmeni Teg",
        edit_tag_rule: "Izmeni pravilo Teg",
        edit_tags: "Izmeni oznake",
        edit_team_member: "Uredi člana tima",
        edit_visibility: "Izmeni vidljivost",
        edit_webhook: "Uredi vebhuk",
        editable_ratings: "Ocene koje se mogu uređivati",
        earned: "Zarađeno",
        eligible: "Ispunjava uslove",
        email: "E-pošta",
        email_address: "Adresa e-pošte",
        email_validation_invalid: "Validacija imejla nije uspela",
        email_validation_passed: "Validacija imejla je prošla",
        email_validation_unknown: "Imejl adresa nije mogla biti verifikovana",
        emails: "Imejlovi",
        embed_code: "Ugradni kod",
        enable: "Omogući",
        enable_automatic_review_collection: "Omogući automatsko prikupljanje recenzija",
        enable_for_all_reviews: "Omogući za sve recenzije",
        enable_for_positive_reviews: "Omogući za pozitivne recenzije",
        enable_on_review_pages: "Omogući na stranicama za Recenzija",
        enabled: "Omogućeno",
        end: "Kraj",
        ends: "Završava se",
        exclude: "Isključi",
        exclude_email: "Isključi imejl",
        exclude_sms: "Isključi SMS",
        excluded_channels: "Isključeni kanali",
        expand: "Proširi",
        expired: "Isteklo",
        export: "Izvoz",
        export_1_customer: "Izvoz 1 kupca",
        export_1_review: "Izvezi 1 Recenzija",
        export_all: "Izvezi sve",
        export_all_customers: "Izvezi sve kupce",
        export_all_reviews: "Izvezi sve Recenzije",
        export_customers: "Izvozni kupci",
        export_n_customers: "Izvoz {count} kupaca",
        export_n_reviews: "Izvoz {count} Recenzije",
        export_reviews: "Izvoz Recenzije",
        external_link: "Spoljni Link",
        external_links: "Spoljni Linkovi",
        extra_locations: "Dodatne lokacije",
        faces: "Lica",
        failed: "Neuspešno",
        feedback: "Povratne informacije",
        field: "Polje",
        fields: "Polja",
        filter: "Filter",
        first: "Prvo",
        first_charged: "Prvo naplaćeno",
        first_name: "Ime",
        first_name_last_initial: "Ime, prezime, inicijal",
        flag_as_duplicate: "Prijavi kao duplikat",
        font: "Font",
        font_family: "Porodica fontova",
        font_size: "Veličina fonta",
        footer: "Futer",
        for: "Za",
        forgot_password: "Zaboravljena lozinka",
        form: "Formular",
        free: "Besplatno",
        free_requests_included: "Uključeni su besplatni zahtevi",
        from: "od",
        full_name: "Puno ime",
        generate: "Generiši",
        generate_meta: "Generiši metapodatke",
        generate_qr_code: "Generiši QR kod",
        generate_reply: "Generiši odgovor",
        generate_review: "Generiši Recenzija",
        generating: "Generisanje",
        get_started: "Započnite",
        get_started_checklist: "Kontrolna lista za početak",
        get_the_lifetime_deal: "Iskoristite doživotnu ponudu",
        getting_started: "Početak rada",
        google_fonts: "Google fontovi",
        grouped_by_request: "Grupisano po zahtevu",
        has_links: "Ima Linkovi",
        has_notes: "Ima beleške",
        has_redirects: "Ima preusmeravanja",
        have_an_account: "Imate nalog?",
        header: "Zaglavlje",
        hidden: "Skriveno",
        hidden_from_search_engines: "Skriveno od pretraživača",
        hidden_reviews: "Skrivene Recenzije",
        hide: "Sakrij",
        hide_all_reviews: "Sakrij sve recenzije",
        hide_avatar: "Sakrij avatar",
        hide_date: "Sakrij datum",
        hide_drop_shadow: "Sakrij padajuću senku",
        hide_field_label: "Sakrij oznaku polja",
        hide_from_public: "Sakrij od javnosti",
        hide_name: "Sakrij ime",
        hide_pagination: "Sakrij paginaciju",
        highlight_color: "Boja isticanja",
        hipaa: "ХИПАА",
        host: "Host",
        hours: "Sati",
        icon: "Ikona",
        icon_size: "Veličina ikone",
        icons: "Ikone",
        id: "ID",
        image: "Slika",
        import: "Uvoz",
        import_address1: "Adresa kupca, red 1.",
        import_address2: "Adresa kupca, red 2.",
        import_city: "Grad ili naselje kupca.",
        import_company: "Naziv kompanije kupca.",
        import_created_at: "Datum recenzije.",
        import_customers: "Uvezi kupce",
        import_email: "Adresa e-pošte klijenta.",
        import_first_name: "Ime kupca.",
        import_from_boost_space: "Uvoz iz Boost.space-a",
        import_from_hubspot: "Uvoz iz HubSpot-a",
        import_from_make_com: "Uvoz sa Make.com",
        import_from_pabbly: "Uvoz iz Pabbly-ja",
        import_from_stripe: "Uvoz iz Stripe-a",
        import_from_zapier: "Uvoz iz Zapier",
        import_last_name: "Prezime kupca.",
        import_list: "Lista odvojena zarezima",
        import_notes: "Napomene samo za internu upotrebu.",
        import_phone: "Broj telefona kupca.",
        import_postal_code: "Poštanski broj kupca.",
        import_recent_reviews: "Uvezi nedavne Recenzije",
        import_review: "Tekst recenzije.",
        import_reviews: "Uvozne Recenzije",
        import_score: "Ocena od 1 do 5.",
        import_signed_up_at: "Datum početka klijenta.",
        import_slug: "slug ili UUID od",
        import_state: "Država ili region kupca.",
        import_yourself: "Uvezi sebe",
        incentive: "Podsticaj",
        include: "Uključi",
        include_sample_reviews: "Укључи примере recenzije",
        incoming_webhook_url: "URL dolaznog vebhuka",
        inherit: "Nasledi",
        initializing: "Inicijalizacija",
        initials: "Inicijali",
        install_in: "Инсталирај у",
        insert_variable: "Umetni promenljivu",
        instructions: "Uputstva",
        integration: "Integracija",
        integrations: "Integracije",
        interval: "Interval",
        introduction: "Uvod",
        invite: "Pozovi",
        invite_client: "Pozovi Klijent",
        invite_failed: "Poziv nije uspeo",
        invite_member: "Pozovi člana",
        invite_sent_to: "Poziv poslat",
        invite_team_member: "Pozovi člana tima",
        invited: "Pozvan",
        issuer_url: "URL издаваоца",
        italic: "Kurziv",
        joined: "Pridružio se",
        key: "Ključ",
        keywords: "Ključne reči",
        keywords_in_replies: "Ključne reči u odgovorima",
        keywords_in_reviews: "Ključne reči u Recenzije",
        kiosk_page: "Kiosk stranica",
        label: "Teg",
        label_font_size: "Veličina fonta nalepnice",
        labels: "Tegovi",
        language: "Jezik",
        languages: "Jezici",
        large: "Veliko",
        last_charged: "Poslednja naplata",
        last_name: "Prezime",
        layout: "Raspored",
        leave: "Odiđi",
        leave_project: "Napusti projekat",
        leave_space: "Napusti Radni prostor",
        left: "Levo",
        let_clients_sign_in_with_sso: "Dozvoli klijentima prijavu putem SSO",
        less: "manje",
        lifecycle_stage: "Faza životnog ciklusa",
        lifetime_deal: "Doživotna ponuda",
        light: "Svetlo",
        limit: "Ograničenje",
        limits: "Ograničenja",
        link: "Link",
        link_color: "Boja linka",
        link_reveal_position: "Pozicija otkrivanja Link",
        link_revealer_button: "Dugme za otkrivanje Link",
        link_revealer_label: "Teg otkrivača Link",
        link_revealer_rating: "Ocena otkrivača Link",
        links: "Linkovi",
        links_per_review_page: "Linkovi po Stranica za recenziju",
        list: "Lista",
        list_unsubscribe_headers: "Zaglavlja za List-Unsubscribe",
        load_more: "Учитај још",
        loading: "Učitavanje",
        location: "Lokacija",
        location_address: "Adresa lokacije",
        location_name: "Naziv lokacije",
        location_picker: "Birač lokacije",
        locations: "Lokacije",
        locations_limit: "Ograničenje lokacija",
        log_in: "Prijavite se",
        log_out: "Odjava",
        logo: "Logo",
        logo_height: "Visina logotipa",
        long: "Dugo",
        lowest_rating: "Najniža ocena",
        ltd: "LTD",
        make_default: "Postavi podrazumevano",
        manage: "Upravljaj",
        manage_limits: "Upravljajte ograničenjima",
        manage_overrides: "Upravljaj zamenama",
        manage_payout_account: "Upravljanje nalogom za isplatu",
        manage_subscription: "Upravljanje pretplatom",
        manual_entry: "Ručni unos",
        max: "Maks",
        max_size: "Maksimalna veličina",
        maximum_characters: "Maksimalan broj Znakovi",
        maximum_customers: "Maksimalan broj kupaca",
        maximum_locations: "Maksimalan broj lokacija",
        maximum_members: "Maksimalan broj članova",
        maximum_review_length: "Maksimalna dužina Recenzija",
        maximum_tags: "Maksimalan Tegovi",
        maximum_widgets: "Maksimalan broj vidžeta",
        mcp: "MCP Server",
        mcp_server: "MCP Server",
        mcp_server_url: "URL MCP Server",
        medium: "Srednji",
        member: "Član",
        members: "Članovi",
        menu: "Мени",
        message: "Poruka",
        message_link_expiration: "Istek Link za poruke",
        messaged: "Poslato",
        messages: "Poruke",
        messages_clicked: "Kliknute poruke",
        messages_sent: "Poslate poruke",
        messaging_service_sid: "SID servisa za razmenu poruka",
        min: "Min.",
        min_size: "Minimalna veličina",
        minimal_delay: "Minimalno kašnjenje",
        minimum_characters: "Minimalan Znakovi",
        minutes: "Minuti",
        month: "mesec",
        monthly: "Mesečno",
        monthly_email_requests: "Mesečni zahtevi za imejl",
        monthly_limit: "Mesečni limit",
        monthly_pricing_only: "Samo mesečne cene",
        monthly_request_limit: "Mesečno ograničenje zahteva",
        monthly_requests: "Mesečni zahtevi",
        monthly_sms_requests: "Mesečni SMS zahtevi",
        months: "Meseci",
        months_free: "{count} Meseci besplatno",
        more: "više",
        more_clients: "više klijenata",
        more_customers: "više kupaca",
        more_options: "Više opcija",
        more_patients: "više pacijenata",
        more_reviews: "više recenzije",
        more_reviews_needed: "Potrebno je više recenzija da bi se rezimiralo",
        more_users: "više korisnika",
        more_visitors: "više posetilaca",
        most_negative: "Najnegativniji",
        most_positive: "Najpozitivniji",
        move: "Pomeri",
        moved: "Premešteno",
        name: "Ime",
        native_reviews: "Recenzije izvornih korisnika",
        negative_term: "Negativni termin",
        negative_trends: "Negativni trendovi",
        new: "Novo",
        new_password: "Nova lozinka",
        newest: "Najnoviji",
        no: "Ne",
        no_available_options: "Nema dostupnih opcija",
        no_credit_card_required: "Nije potrebna kreditna kartica",
        no_data_available: "Nema dostupnih podataka",
        no_negative_trends: "Još uvek nema negativnih trendova",
        no_positive_trends: "Još nema pozitivnih trendova",
        no_reminders: "Не шаљите подсетнике",
        no_retries: "Bez ponovnih pokušaja",
        no_review: "Bez recenzije",
        none: "Nijedan",
        not_connected: "Nije povezano",
        not_reviewed: "Nije Recenzirano",
        notes: "Beleške",
        notifications: "Obaveštenja",
        now: "Sada",
        number_of_charges: "Broj naplata",
        number_of_reminders: "Broj podsetnika",
        number_of_retries: "Broj ponovnih pokušaja",
        number_of_review_suggestions: "Broj predloga za Recenzija",
        of: "od",
        off: "Isključeno",
        on: "Uključeno",
        on_channel: "na kanalu {channel}.",
        opened: "Otvoreno",
        options: "Opcije",
        or_log_in_with_email: "ili se prijavite sa svojom imejl adresom",
        or_sign_up_with_email: "ili koristite svoju adresu e-pošte",
        our_reviews: "Naše Recenzije",
        output: "Izlaz",
        page_footer: "Podnožje stranice",
        paid: "Plaćeno",
        paragraph: "Pasus",
        password: "Lozinka",
        past_month: "Prošli mesec",
        past_months: "Proteklih {inc} meseci",
        past_week: "Prošla nedelja",
        past_year: "Prošla godina",
        past_years: "Prošle {inc} godine",
        paused: "Pauzirano",
        payment_method: "Način plaćanja",
        payout_status_completed: "Završeno",
        payout_status_pending: "Na čekanju",
        pending: "Na čekanju",
        pending_deployment: "Čeka se raspoređivanje",
        pending_validation: "Čeka se validacija",
        per_day: "dnevno",
        per_month: "mesečno",
        permissions: "Dozvole",
        phone: "Telefon",
        phone_number: "Broj telefona",
        pixels: "pikseli",
        placeholder: "Čuvar mesta",
        placement: "Plasman",
        plan: "Plan",
        plan_bullet1: "Uklonite naš brending iz imejlova, stranica i vidžeta",
        plan_bullet2: "Koristite svoj domen za stranice okrenute kupcima i slanje imejlova",
        plan_bullet3: "Prilagodite proizvod sebi uz belo obeležavanje za agencije",
        please_rate_our_service: "Molimo vas da ocenite našu uslugu",
        png: "PNG",
        policies: "Politike",
        popular: "Popularno",
        port: "Port",
        position: "Pozicija",
        positive_only: "Samo pozitivne Recenzije",
        positive_term: "Pozitivan termin",
        positive_trends: "Pozitivni trendovi",
        powered_by: "Pokreće",
        preview: "Pregled",
        preview_kiosk_page: "Pregled stranice kioska",
        preview_review_page: "Pregled stranice za recenziju",
        price: "Cena",
        pricing: "Cene",
        primary_color: "Osnovna boja",
        priority: "Prioritet",
        privacy_policy: "Politika privatnosti",
        proceed_to_dashboard: "Idite na kontrolnu tablu",
        product: "Proizvod",
        profile: "Profil",
        project: "Projekat",
        project_name: "Naziv projekta",
        setup_ask_delay: "Колико дуго треба чекати пре него што се затражи преглед",
        setup_reminders: "Колико подсетника послати",
        project_paused: "Ovaj projekat je pauziran.",
        project_suspended: "Ovaj projekat je obustavljen.",
        project_website: "Veb-sajt projekta",
        projects: "Projekti",
        projects_limit: "Ograničenje projekata",
        publish: "Objavi",
        publish_changes: "Objavite izmene na svim ostalim stranicama za recenzije",
        published: "Objavljeno",
        purchase: "Kupovina",
        qr_code: "QR kod",
        qr_code_name_placeholder: "Sto 1, Recepcija",
        qr_codes: "QR kodovi",
        quantity: "Količina",
        query: "Upit",
        quick_import: "Brzi uvoz",
        rating: "Ocena",
        rating_order: "Redosled ocenjivanja",
        rating_out_of: "ocena van",
        rating_save_all: "Sačuvaj ocenu pre svake recenzije",
        rating_save_customer: "Sačuvaj ocenu pre nego što napiše recenziju kupca",
        rating_save_never: "Nikada ne sačuvaj ocenu pre recenzije",
        rating_selection: "Izbor ocene",
        rating_selector: "Selektor ocena",
        ratings: "Ocene",
        read: "Čitaj",
        reapply_highlights_eligible: "Regenerišite istaknute stavke pomoću veštačke inteligencije za sve pozitivne recenzije",
        reconnect: "Ponovo se povežite",
        redeem: "Iskoristi",
        redirect_uri: "URI за преусмеравање",
        redirects: "Preusmeravanja",
        refer_and_earn: "Preporučite i zaradite",
        referral_billing_status_active: "Pretplaćeni",
        referral_billing_status_canceled: "Otkazano",
        referral_billing_status_trial: "Probni period",
        referral_billing_status_trial_expired: "Probni period je istekao",
        referral_billing_status_trial_expiring: "Probni period ističe",
        referral_program: "Uslovi programa preporuka",
        referral_program_terms: "Услови програма препорука",
        referrals: "Preporuke",
        refresh: "Osveži",
        regenerate: "Regeneriši",
        reject_all: "Odbij sve",
        related_reviews: "Slične Recenzije",
        related_similarity: "Sličnost",
        remaining: "Preostalo",
        reminder: "Podsetnik",
        reminders: "Podsetnici",
        remove: "Ukloni",
        remove_client: "Ukloni Klijent",
        remove_cname: "Ukloni CNAME",
        remove_domain: "Ukloni domen",
        remove_from_project: "Ukloni iz projekta",
        remove_member: "Ukloni člana",
        remove_smtp_configuration: "Ukloni SMTP konfiguraciju",
        remove_team_member: "Ukloni člana tima",
        rename: "Preimenuj",
        rename_template: "Preimenuj šablon",
        renews: "Obnavlja",
        replied: "Odgovoreno",
        reply: "Odgovor",
        reply_to: "Adresa za odgovor",
        replying_on: "Odgovaranje na",
        request: "Zahtev",
        request_1_review: "Zatraži 1 recenziju",
        request_date: "Datum zahteva",
        request_n_reviews: "Zatraži {count} recenzija",
        request_review: "Zahtevajte Recenzija",
        request_reviews: "Zahtevajte Recenzije",
        requested: "Zahtevano",
        requested_review: "Zahtevan Recenzija",
        requests: "Zahtevi",
        requests_left_this_month: "zahtevi preostali ovog meseca",
        requests_remaining: "Preostali zahtevi",
        require_field: "Obavezno polje",
        require_sso: "Захтевај једнократно пријављивање (SSO)",
        required: "Obavezno",
        reschedule_message: "Ponovo zakažite poruku",
        resend_invite: "Ponovo pošalji poziv",
        reset_password: "Resetuj lozinku",
        restore: "Vrati",
        restore_to_defaults: "Vrati na podrazumevane vrednosti",
        restore_widget: "Vrati vidžet",
        resubscribe: "Ponovo se pretplatite",
        resubscribe_customer: "Ponovo se pretplatite, korisnik",
        resync: "Ponovo sinhronizuj",
        resync_account: "Ponovo sinhronizuj nalog",
        resync_now: "Ponovo sinhronizuj sada",
        retries: "Ponovni pokušaji",
        reveal_above_form: "Otkrij iznad formulara",
        reveal_after_submission: "Otkrij nakon slanja",
        reveal_below_form: "Otkrij ispod formulara",
        review: "Recenzija",
        review_length: "Dužina Recenzija",
        review_link: "Link za Recenzija",
        review_missed: "Propušten Recenzija",
        review_not_requested: "Recenzija nije zahtevan",
        review_origin: "Ova recenzija je potekla iz šablona",
        review_page: "Stranica za recenziju",
        review_pages: "Stranice za recenzije",
        review_requested: "Recenzija zatražena",
        review_spotlight: "Istaknuta recenzija",
        review_suggestion: "Predlog za Recenzija",
        review_suggestions: "Predlozi za Recenzija",
        review_text: "Tekst Recenzija",
        review_wall: "Zid recenzija",
        reviewed: "Recenzirano",
        reviews: "Recenzije",
        reviews_ask: "Pitajte",
        reviews_query_failed: "Došlo je do greške. Molimo vas pokušajte ponovo.",
        reviews_query_placeholder: "Pretražite recenzije ili postavite pitanje...",
        reviews_with_highlights: "Recenzije sa istaknutim detaljima",
        reviews_with_replies: "Recenzije sa odgovorima",
        reviews_without_replies: "Recenzije bez odgovora",
        revoke: "Poništi",
        revoke_client: "Poništi aplikaciju",
        roadmap: "Plan puta",
        role: "Uloga",
        sans_serif: "Sans serif",
        save: "Sačuvaj",
        save_preferences: "Sačuvaj podešavanja",
        save_template: "Sačuvaj šablon",
        save_template_as_new: "Sačuvaj novi šablon",
        saved: "Sačuvano",
        schedule: "Raspored",
        schedule_review_request: "Zakažite zahtev za recenziju",
        scheduled: "Zakazano",
        score: "Rezultat",
        search: "Pretraga",
        second: "Drugi",
        secret_key: "Tajni ključ",
        sections: "Odeljci",
        security_code: "Bezbednosni kod",
        select: "Izaberite",
        select_account: "Izaberite nalog",
        select_all: "Izaberi sve",
        select_an_option: "Izaberite opciju",
        select_bulk_action: "Izaberite grupnu akciju",
        select_csv_file: "Izaberite CSV datoteku",
        select_date: "Izaberite datum",
        select_field: "Izaberite polje",
        select_icon: "Izaberite ikonu",
        select_location: "Izaberite lokaciju",
        select_plan: "Izaberite plan",
        select_review: "Izaberite Recenzija",
        select_source: "Izaberite izvor",
        select_tag: "Izaberite Teg",
        selected: "Izabrano",
        send: "Pošalji",
        send_1_reminder: "Pošalji 1 podsetnik",
        send_2_reminders: "Pošalji 2 podsetnika",
        send_3_reminders: "Pošalji 3 podsetnika",
        send_anytime: "Pošalji bilo kada",
        send_between: "Pošalji između",
        send_message: "Pošalji poruku",
        send_retries: "Pošalji {count} ponovnih pokušaja",
        send_retry: "Pošalji {count} Pokušaj ponovo",
        send_test: "Pošalji test",
        send_thanks: "Pošalji zahvalnicu",
        sender_email_address: "Adresa e-pošte pošiljaoca",
        sender_id: "ID pošiljaoca",
        sender_name: "Ime pošiljaoca",
        sending_domain: "Domen slanja",
        sentiment: "Sentiment",
        sent: "Poslato",
        sent_replies: "Poslati odgovori",
        serif: "Serif",
        settings: "Podešavanja",
        share: "Deli",
        share_link: "Deli Link",
        short: "Kratak",
        show: "Prikaži",
        show_1_suggestion: "Prikaži jedan predlog",
        show_100_results: "Prikaži 100 rezultata",
        show_2_suggestions: "Prikaži dva predloga",
        show_25_results: "Prikaži 25 rezultata",
        show_3_suggestions: "Prikaži tri predloga",
        show_4_suggestions: "Prikaži četiri predloga",
        show_5_suggestions: "Prikaži pet predloga",
        show_50_results: "Prikaži 50 rezultata",
        show_all_reviews: "Prikaži sve recenzije",
        show_arrows: "Prikaži strelice",
        show_avatar: "Prikaži avatar",
        show_cookie_consent_banner: "Prikaži baner saglasnosti za kolačiće",
        show_date: "Prikaži datum",
        show_dots: "Prikaži tačke",
        show_drop_shadow: "Prikaži padajuću senku",
        show_field: "Prikaži polje za sledeće ocene",
        show_full: "Prikaži sve zvezdice",
        show_photo: "Prikaži samo fotografiju",
        show_positive_reviews: "Prikaži samo pozitivne recenzije",
        show_to_public: "Prikaži javnosti",
        showcase: "Showcase",
        showcase_page: "Stranica za prezentaciju",
        sign_up: "Registruj se",
        sign_up_for_free: "Registrujte se besplatno",
        sign_up_with_email: "Registrujte se e-poštom",
        sign_in_with_sso: "Пријавите се помоћу SSO-а",
        sign_up_with_google: "Registrujte se sa Google",
        signature: "Potpis",
        signatures: "Potpisi",
        signed_up: "Registrovan\/a",
        since: "Od",
        size: "Veličina",
        skip: "Прескочи",
        slug: "Slug",
        small: "Mali",
        sms: "SMS",
        smtp_configuration: "SMTP konfiguracija",
        sort: "Sortiraj",
        source: "Izvor",
        source_code: "Izvorni kod",
        sources: "Izvori",
        space: "Radni prostor",
        space_name: "Naziv Radni prostor",
        spaces: "Radni prostori",
        split: "Podela",
        sso: "SSO",
        star_color: "Boja zvezde",
        stars: "Zvezde",
        start: "Početak",
        start_free_trial: "Započni besplatnu probnu verziju",
        start_getting_more_reviews: "Počnite da dobijate više Recenzije",
        status: "Status",
        store_code: "Šifra prodavnice",
        strategy: "Strategija",
        sub_processors: "Podobrađivači",
        subject: "Predmet",
        subscribe: "Pretplatite se",
        subscription: "Pretplata",
        success_page: "Stranica uspeha",
        suggestion: "Predlog",
        suggestions: "Predlozi",
        summary: "Rezime",
        support: "Podrška",
        suspend: "Suspenduj",
        suspend_project: "Obustavi projekat",
        suspended: "Suspendovano",
        svg: "SVG",
        switch_to_smtp_setup: "Pređi na podešavanje SMTP-a",
        switch_to_standard_setup: "Pređi na standardno podešavanje",
        symbol: "Simbol",
        sync: "Sinhronizacija",
        sync_account: "Sinhronizacija naloga",
        sync_now: "Sinhronizuj sada",
        sync_scheduled_time: "Синхронизација је заказана {time}",
        sync_with_facebook: "Sinhronizuj sa Facebook",
        sync_with_google: "Sinhronizuj sa Google",
        synced_time: "Синхронизовано {time}",
        system: "Sistem",
        system_fonts: "Sistemski fontovi",
        tag: "Teg",
        tag_1_customer: "Teg 1 Kupac",
        tag_1_review: "Recenzija Teg 1",
        tag_customers: "Označi korisnike",
        tag_existing_reviews: "Teg postojeće Recenzije",
        tag_n_customers: "Teg {count} Kupci",
        tag_n_reviews: "Teg {count} Recenzije",
        tag_reviews: "Označi recenzije",
        tag_rule: "Pravilo tegovi",
        tag_with_ai: "Označi pomoću veštačke inteligencije",
        tags: "Tegovi",
        tags_for_customers: "Tegovi za kupce",
        tags_for_reviews: "Tegovi za Recenzije",
        team: "Tim",
        team_member: "Član tima",
        team_members: "Članovi tima",
        template: "Šablon",
        templates: "Šabloni",
        terms_of_service: "Uslovi korišćenja usluge",
        test_template: "Šablon za testiranje",
        tests: "Testovi",
        text: "Tekst",
        text_alignment: "Poravnanje teksta",
        text_color: "Boja teksta",
        thank_you_messages: "Poruke zahvalnosti",
        thanks: "Hvala",
        theme: "Tema",
        third: "Treći",
        time_zone: "Vremenska zona",
        timeframe: "Vremenski okvir",
        title: "Naslov",
        tone: "Ton",
        top: "Vrh",
        top_left: "Gore levo",
        top_right: "Gore desno",
        total_charges: "Ukupni troškovi",
        total_reviews: "Ukupan broj Recenzije",
        trigger: "Okidač",
        trigger_charged: "Pošalji zahtev nakon naplate",
        trigger_created: "Pošalji zahtev nakon registracije",
        try_free: "Probajte besplatno",
        try_it_free: "Isprobajte besplatno",
        type: "Tip",
        types: "Vrste",
        unarchive: "Vrati iz arhive",
        unarchive_customer: "Vrati arhivu kupca",
        underline: "Podvučeno",
        unflag_as_duplicate: "Ukloni oznaku kao duplikat",
        unknown: "Nepoznato",
        unlimited: "neograničeno",
        unnamed: "Neimenovano",
        unpublish: "Opozovi objavljivanje",
        unpublished: "Neobjavljeno",
        unreplied: "Neodgovoreno",
        unsent_messages: "Neposlate poruke",
        unsubscribe: "Odjavi se",
        unsubscribe_1_customer: "Odjavi 1 kupca",
        unsubscribe_customer: "Odjavite pretplatnika",
        unsubscribe_customers: "Odjavite se sa pretplate",
        unsubscribe_n_customers: "Odjavi {count} kupaca",
        unsubscribe_text: "Tekst za odjavu",
        unsubscribed: "Odjavljeni",
        unsuspend: "Ukloni suspenziju",
        unsuspend_project: "Ukloni suspenziju projekta",
        unverified: "Neprovereno",
        update: "Ažuriranje",
        update_password: "Ažuriraj lozinku",
        update_plan: "Ažuriraj plan",
        update_share_template: "Ažuriraj šablon",
        updated: "Ažurirano",
        updates: "Ažuriranja",
        upgrade: "Nadogradnja",
        upgrade_for_more: "Nadogradite za više",
        upgrade_to_use: "Molimo vas da nadogradite da biste koristili ovu funkciju",
        upload: "Otpremi",
        upload_csv: "Otpremi CSV",
        upload_icon: "Otpremi ikonu",
        url: "URL",
        use: "Koristite",
        use_filters_for_aggregate: "Koristite filtere za agregirane podatke",
        user: "Korisnik",
        user_id: "ID korisnika",
        user_info: "Informacije o korisniku",
        username: "Korisničko ime",
        utc: "UTC",
        validate: "Validiraj",
        validate_customer_email: "Potvrdite imejl adresu klijenta",
        validation: "Validacija",
        validations: "Validacije",
        value: "Vrednost",
        verify: "Verifikuj",
        verify_email_address: "Verifikujte adresu e-pošte",
        view: "Pogledaj",
        view_all: "Prikaži sve",
        view_all_features: "Pogledajte sve funkcije",
        view_available_fields: "Pogledajte dostupna polja",
        view_documentation: "Pogledajte dokumentaciju",
        view_email_templates: "Pogledajte šablone imejlova",
        view_review_pages: "Pogledajte Stranice za recenzije",
        view_reviews: "Pogledajte Recenzije",
        view_settings: "Podešavanja prikaza",
        view_setup_guide: "Pogledajte vodič za podešavanje",
        view_showcase: "Pogledajte prezentaciju",
        view_strategy: "Pogledajte strategiju",
        visibility: "Vidljivost",
        visible: "Vidljivo",
        visible_reviews: "Vidljive Recenzije",
        visible_to_search_engines: "Vidljivo pretraživačima",
        wait_between_reminders: "Sačekajte između podsetnika",
        wait_period: "Period čekanja",
        webhook: "Vebhuk",
        webhooks: "Vebhukovi",
        website: "Veb-sajt",
        weekly: "Nedeljno",
        weeks: "Nedelje",
        widget: "Vidžet",
        widgets: "Vidžeti",
        with_ai: "sa veštačkom inteligencijom",
        worst_to_best: "Od najgoreg do najboljeg",
        write: "Piši",
        written_reviews: "Pisane Recenzije",
        year: "godina",
        yearly: "Godišnje",
        yes: "Da",
        your_referral_link: "Vaš referalni Link"
    },
    landing: {
        announcement: "Dobijte izveštaje o reputaciji pomoću našeg MCP servera",
        counter: "Pridružite se preko 5.000 lokalnih uslužnih preduzeća",
        counter_agencies: "Koristi 500+ agencija za upravljanje recenzijama",
        counter_ai: "Управљајте репутацијом од стране Claude & ChatGPT",
        ai_screen_1_badge: "MCP",
        ai_screen_1_bullets: [
            "Добијте одговоре без пријављивања на другу контролну таблу",
            "Реагујте на репутацију у алатима за ћаскање које ваш тим већ отвара",
            "Sačuvaj сате сваке недеље питајући уместо копајући"
        ],
        ai_screen_1_subtitle: "Vaš rad na reputaciji trebalo bi da vas dočeka tamo gde već razmišljate. Pitajte Claude ili ChatGPT na šta treba odgovoriti, koga sledeće pitati ili kako je prošla nedelja i dobijte odgovore uživo bez promene alata.",
        ai_screen_1_title: "Pitajte Claude ili ChatGPT",
        ai_screen_2_badge: "Одговори вештачке интелигенције",
        ai_screen_2_bullets: [
            "Одговарајте брже, а да не звучите генерички",
            "Никада не остављајте recenzije без одговора када сте заузети",
            "Заштитите глас свог бренда у сваком јавном одговору"
        ],
        ai_screen_2_subtitle: "Svaka neodgovorena recenzija je propuštena šansa da se zasluži poverenje. Veštačka inteligencija piše odgovore koji liče na vas, tako da možete da obrišete red za nekoliko minuta i ostanete prisutni za kupce bez muke oko pisanja.",
        ai_screen_2_title: "Odgovorite bez muke",
        ai_screen_3_badge: "Предлози вештачке интелигенције",
        ai_screen_3_bullets: [
            "Доведите више купаца до циља",
            "Прикупљајте повратне информације које су конкретне и које се могу делити",
            "Претворите задовољне посете у recenzije вредне хвале"
        ],
        ai_screen_3_subtitle: "Većina ljudi namerava da ostavi recenziju, ali to nikada ne učini. Dajte im jasne formulacije svojim glasom kako bi više završilo, i kako bi ono što napišu bilo dovoljno snažno da se istakne.",
        ai_screen_3_title: "Dobijte još recenzija sa 5 zvezdica",
        ai_screen_4_badge: "АИ означавање",
        ai_screen_4_bullets: [
            "Уочите обрасце пре него што постану проблеми",
            "Пронађите теме које заиста померају оцене",
            "Прескочите читање стотина recenzije ручно"
        ],
        ai_screen_4_subtitle: "Ne bi trebalo da morate ponovo da čitate svaku recenziju da biste znali šta se dešava. Veštačka inteligencija organizuje povratne informacije u teme koje vas zanimaju, tako da možete brže da rešite probleme i udvostručite ono što kupci vole.",
        ai_screen_4_title: "Znajte šta kupci govore",
        ai_summary_1_desc: "Направите нацрте одговора за Google и Facebook који одговарају вашем тону или аутоматски одговорите по распореду.",
        ai_summary_1_title: "Одговори вештачке интелигенције",
        ai_summary_2_desc: "Дајте купцима спремне предлоге за рецензије када оставе повратне информације на вашој страници.",
        ai_summary_2_title: "Предлози за преглед вештачке интелигенције",
        ai_summary_3_desc: "Истакните најбоље фразе у позитивним recenzije на виџетима, представите их и делите слике.",
        ai_summary_3_title: "Најважније информације о вештачкој интелигенцији",
        ai_summary_4_desc: "Примените tegovi из правила која дефинишете како би теме попут времена чекања или квалитета услуге остале организоване.",
        ai_summary_4_title: "Аутоматско обележавање помоћу вештачке интелигенције",
        ai_summary_5_desc: "Добијте сажете прегледе скорашњих recenzije са бројем, темама и проблемима на које вреди реаговати.",
        ai_summary_5_title: "Резимеи Recenzija",
        ai_summary_6_desc: "Уочите све веће похвале и нове жалбе без ручног читања сваке рецензије.",
        ai_summary_6_title: "Позитивни и негативни трендови",
        ai_summary_7_desc: "Пронађите сличне recenzije поред било које повратне информације како би се обрасци и понављања лако видели.",
        ai_summary_7_title: "Повезане recenzije",
        ai_summary_8_desc: "Постављајте питања о својим recenzije написана једноставним језиком и добијајте одговоре уз цитате које можете отворити.",
        ai_summary_8_title: "Питајте вештачку интелигенцију",
        ai_summary_9_desc: "Повежите Claude, ChatGPT и друге MCP клијенте да бисте управљали репутацијом у ћаскању.",
        ai_summary_9_title: "MCP за асистенте",
        ai_summary_10_desc: "Прикупљајте извештаје о репутацији уживо који покривају обим, оцене, локације, одговоре и досег.",
        ai_summary_10_title: "Извештаји о репутацији",
        ai_summary_11_desc: "Водећи тон, кључне речи и прилагођена упутства како би сваки вештачки интелигентни излаз звучао као ваш бренд.",
        ai_summary_11_title: "Вештачка интелигенција свесна бренда",
        ai_summary_12_desc: "Оцените колико су писане рецензије позитивне или негативне, изван звезда, и сортирајте оно што захтева пажњу.",
        ai_summary_12_title: "Сентимент",
        industries: {
            accountants: "Računovođe",
            auto_repair: "Auto mehaničari",
            chiropractors: "Kiropraktičari",
            cleaning: "Čistači",
            contractors: "Izvođači radova",
            dentists: "Stomatolozi",
            doctors: "Lekari",
            electricians: "Električari",
            financial_advisors: "Finansijski savetnici",
            hvac: "HVAC tehničari",
            insurance_brokers: "Brokeri osiguranja",
            landscapers: "Pejzažisti",
            law_firms: "Advokati",
            locksmiths: "Bravari",
            mortgage_brokers: "Hipotekarni brokeri",
            optometrists: "Optometristi",
            personal_trainers: "Personalni treneri",
            pest_control: "Deratizeri",
            physical_therapists: "Fizioterapeuti",
            plumbers: "Vodoinstalateri",
            real_estate: "Agenti za nekretnine",
            restaurants: "Vlasnici restorana",
            salons: "Frizeri",
            self_storage: "Operateri skladišta",
            spas: "Estetičari",
            tour_guides: "Turistički vodiči",
            veterinarians: "Veterinari"
        },
        industries_title: "Upravljanje recenzijama za lokalne uslužne biznise",
        stat_1_article: "Извештај о истраживању потрошача",
        stat_1_desc: "Људи желе више од 100 recenzije пре него што поверују неком предузећу на мрежи.",
        stat_1_source: "Козец",
        stat_1_title: "Recenzije заслужују поверење",
        stat_2_article: "Recenzija локалних потрошача",
        stat_2_desc: "Купци који упоређују локалне фирме преферирају оне које одговарају на сваку рецензију.",
        stat_2_source: "БрајтЛокал",
        stat_2_title: "Изаберите ко одговара",
        stat_3_article: "Recenzije, репутација и приход",
        stat_3_desc: "Мало повећање рејтинга може значити право повећање ваше зараде.",
        stat_3_source: "Харвардска пословна школа",
        stat_3_title: "Приход по звездици",
        stat_4_article: "Ослањање потрошача на резултате претраге вештачке интелигенције",
        stat_4_desc: "Када људи питају вештачку интелигенцију кога да изабере, ваше recenzije помажу у писању одговора.",
        stat_4_source: "Бејн и компанија",
        stat_4_title: "Ослоните се на вештачку интелигенцију претраге",
        subtitle: "Zahtevajte recenzije automatski. Dobijte više ocena od 5 zvezdica. Rangirajte se bolje od konkurencije.",
        agencies_screen_1_badge: "Портал",
        agencies_screen_1_bullets: [
            "Продајте брендирани портал уз сваки ангажман",
            "Задржите клијенте у свом екосистему, а не у пријави треће стране",
            "Изгледајте као софтверска компанија, а да је не направите"
        ],
        agencies_screen_1_subtitle: "Dajte svakom klijentu portal koji izgleda kao proizvod koji ste vi napravili: vaš logo, boje, domen. Zatim spakujte upravljanje recenzijama kao ponavljajuću uslugu na koju se prijavljuju svakog meseca. Ne preporučujete alat. Isporučujete ga.",
        agencies_screen_1_title: "Portal za koji misle da ste ga vi napravili",
        agencies_screen_2_badge: "Контрола",
        agencies_screen_2_bullets: [
            "Ускладите функције са почетним, растућим и премијум пакетима",
            "Позовите праве људе и контролишите шта сваки клијент види",
            "Замени захтеве, локације и ограничења по пројекту"
        ],
        agencies_screen_2_subtitle: "Ne treba svaki klijent da dobije sve. Pozovite timove na određene projekte, postavite uloge i prepišite funkcije i limite po nalogu da paketi odgovaraju naplati. Upsellujte pristup kako klijenti rastu, bez custom buildova za svaki paket.",
        agencies_screen_2_title: "Kontrolišite pristup po klijentu",
        agencies_screen_3_badge: "Вештачка интелигенција",
        agencies_screen_3_bullets: [
            "Понудите вештачке одговоре који клијентима sačuvaj сате сваке недеље",
            "Повежите Claude или друге асистенте преко MCP а сваког пројекта",
            "Productize AI као премиум додатак за клијенте"
        ],
        agencies_screen_3_subtitle: "Ne samo upravljajte recenzijama. Dajte klijentima AI koji piše odgovore, taguje feedback i radi preko Claude ili drugih asistenata preko MCP servera projekta. To je moderna mogućnost koju agencije mogu da pakuju, upselluju i obnavljaju — bez content tima za svaki nalog.",
        agencies_screen_3_title: "AI za koji će klijenti platiti",
        agencies_screen_4_badge: "Скала",
        agencies_screen_4_bullets: [
            "Управљајте recenzije за више предузећа са једног налога",
            "Додајте локације како их освајате, уз количинско одређивање цена",
            "Претворите сваког новог клијента у стални приход"
        ],
        agencies_screen_4_subtitle: "Jedno mesto agencije. Desetine biznisa. Vodite prikupljanje, odgovore i izveštavanje na svim lokacijama klijenata iz jednog huba, pa rastite maržu dodavanjem naloga. Tako agencije pretvaraju reputaciju u skalabilan prihod, a ne jednokratni projekat.",
        agencies_screen_4_title: "Skalirajte na svakom klijentu",
        agencies_summary_10_desc: "Повежите Claude или друге асистенте да управљају пројектима, клијентима и тимом.",
        agencies_summary_10_title: "Агенција MCP",
        agencies_summary_11_desc: "Сваки клијент добија комплетан комплет алата за рецензију: колекцију, вештачку интелигенцију, виџете и још много тога.",
        agencies_summary_11_title: "Све у бизнису",
        agencies_summary_12_desc: "Потражите помоћ од тима који разуме токове рада агенције и имплементацију код клијената.",
        agencies_summary_12_title: "Посвећена подршка",
        agencies_summary_1_desc: "Klijenti управљају репутацијом на порталу који изгледа као производ који сте ви направили.",
        agencies_summary_1_title: "Брендирани клијентски портал",
        agencies_summary_2_desc: "Покрените портал на свом домену тако да свака пријава остане на вашем бренду.",
        agencies_summary_2_title: "Домен прилагођене агенције",
        agencies_summary_3_desc: "Омогућите клијентима да се пријаве код вашег добављача идентитета једним кликом.",
        agencies_summary_3_title: "Једнократно пријављивање",
        agencies_summary_4_desc: "Позовите клијенте на одређене пројекте и контролишите шта могу да виде.",
        agencies_summary_4_title: "Позиви и улоге Klijent",
        agencies_summary_5_desc: "Ограничите захтеве, локације и функције по пројекту како би се ускладили са вашим пакетима.",
        agencies_summary_5_title: "Замене по пројекту",
        agencies_summary_6_desc: "Дајте свом интерном тиму потпун приступ сваком клијентском пројекту.",
        agencies_summary_6_title: "Седишта агенцијског тима",
        agencies_summary_7_desc: "Почните са 5 локација, а затим додајте још уз количинско одређивање цена како растете.",
        agencies_summary_7_title: "Вишеструка локациона скала",
        agencies_summary_8_desc: "Системска обавештења се шаљу са домена ваше агенције и по пројекту када клијенти нису додали своја.",
        agencies_summary_8_title: "Слање беле етикете",
        agencies_summary_9_desc: "Аутоматизујте пројекте, клијенте и тим помоћу агенцијског API-ја.",
        agencies_summary_9_title: "API агенције",
        demo_footer: "Izaberite vreme koje vam odgovara. Proći ćemo kroz sve i odgovoriti na pitanja.",
        desc_contact: "Imate pitanje ili vam treba pomoć oko nečega? Pošaljite poruku ispod — mi ćemo se pobrinuti za ostatak.",
        mcp_aria: "Демонстрација вештачке интелигенције повезана са More Good Reviews преко MCP-а",
        mcp_prompts_aria: "Примери упита",
        review_flow_aria: "Карусел са картицама који приказује захтеве за рецензије путем е-поште, страницу са рецензијама, Google recenzije и приватне повратне информације",
        review_flow_autopilot: "Ради на аутопилоту",
        review_flow_card_email_desc: "Када завршите са клијентом, аутоматски вам шаљемо брендирани захтев са линком који води до ваше странице за рецензије једним додиром.",
        review_flow_card_email_title: "Пошаљи захтев",
        review_flow_card_feedback_desc: "Ниже оцене прво отварају приватне повратне информације како бисте могли да их исправите. Klijenti и даље могу да изаберу јавну рецензију.",
        review_flow_card_feedback_title: "Ухватите тешке повратне информације",
        review_flow_card_google_desc: "Задовољни купци добијају јасан пут да оставе јавну рецензију на Google , тако да се похвале приказују тамо где их нови купци гледају.",
        review_flow_card_google_title: "Пошаљите похвалу Google",
        review_flow_card_review_desc: "Слете на вашу страницу са рецензијама, изаберу оцену, а следећи корак зависи од тога како су ствари ишле.",
        review_flow_card_review_title: "Klijent бира оцену",
        review_flow_next: "Следећи корак",
        review_flow_prev: "Претходни корак",
        review_flow_step_email: "Zahtev Recenzija",
        review_flow_step_feedback: "или затражите повратне информације",
        review_flow_step_google: "Рута до било којег сајта за Recenzija",
        review_flow_step_review: "Затражите Ocena",
        review_flow_steps_aria: "Кораци захтева за Recenzija",
        summary_10_desc: "Организујте купце и recenzije како бисте могли да филтрирате и брзо реагујете.",
        summary_10_title: "Означавање Klijent и рецензија",
        summary_11_desc: "Zapier повезује „Још More Good Reviews“ са алатима које већ користите.",
        summary_11_title: "Повежите се са било којом апликацијом",
        summary_12_desc: "Управљајте репутацијом из Claude, ChatGPT и других MCP клијената.",
        summary_12_title: "MCP за AI асистенте",
        summary_1_desc: "Заказано слање имејлова и SMS порука са подсетницима, на аутопилоту.",
        summary_1_title: "Аутоматски захтеви за преглед",
        summary_2_desc: "Е-пошта и SMS које одговарају вашем бренду, гласу и понуди.",
        summary_2_title: "Брендирани шаблони",
        summary_3_desc: "Прикупљајте приватне повратне информације или шаљите људе на Google, Facebook и друге платформе.",
        summary_3_title: "Странице за Recenzija",
        summary_4_desc: "Кодови за штампање и преузимање у продавници преко целог екрана.",
        summary_4_title: "QR кодови и киоск",
        summary_5_desc: "Уградите оцене и recenzije било где на вашој веб страници.",
        summary_5_title: "Виџети за веб сајтове",
        summary_6_desc: "Јавна, брендирана страница за ваше најбоље recenzije.",
        summary_6_title: "Страница за Showcase",
        summary_7_desc: "Uvezi recenzije и одговарајте са једног места.",
        summary_7_title: "Синхронизација са Google и Фејсбуком",
        summary_8_desc: "Предлози на страници који помажу купцима да оставе рецензију.",
        summary_8_title: "Помоћ при писању рецензија вештачке интелигенције",
        summary_9_desc: "Направите нацрте одговора, резимеа, трендова и питајте вештачку интелигенцију о својим recenzije.",
        summary_9_title: "Одговори и увиди вештачке интелигенције",
        subtitle_agencies_feature_summary: "White label portal, pristup klijenata, skala i automatizacija pod vašim brendom.",
        subtitle_ai_feature_summary: "Одговори, означавање, увиди и помоћници уграђени у ваш ток рада са репутацијом.",
        subtitle_feature_summary: "Prikupljanje, prikaz, AI i integracije — spremno kad i vi budete.",
        subtitle_mcp: "Povežite Claude, ChatGPT i druge MCP klijente, pa pitajte o recenzijama, lokacijama i outreach-u prirodnim jezikom.",
        subtitle_review_flow: "Tražite recenzije automatski. Klijenti mogu ostaviti javnu recenziju bilo kada. Privatni feedback je opcionalan.",
        title: "AI upravljanje reputacijom da",
        title_agencies: "Pretvorite recenzije u",
        title_agencies_feature_summary: "Sve što agencijama treba",
        title_agencies_phrases: {
            branded_product: "brendiran proizvod koji je vaš",
            recurring_retainers: "mesečne ponavljajuće retainere",
            revenue_stream: "novi izvor prihoda"
        },
        title_ai: "Pitajte svoju veštačku inteligenciju",
        title_ai_feature_summary: "Sve što veštačka inteligencija može da uradi za vas",
        title_ai_phrases: {
            weekly_report: "za nedeljni izveštaj o reputaciji",
            send_from_chat: "da pošalje zahteve za recenziju",
            next_steps: "za sledeće korake koje treba preduzeti"
        },
        title_contact: "Kako možemo pomoći?",
        title_faq: "Česta pitanja",
        title_feature_summary: "Sve u jednom paketu",
        title_footer: "Prestanite da jurite recenzije. Počnite da ih dobijate.",
        title_footer_ai: "o vašoj reputaciji",
        title_ltd: "Platite jednom i koristite zauvek uz našu vremenski ograničenu doživotnu ponudu",
        title_mcp: "Pitajte AI o svojoj reputaciji",
        title_review_flow: "Pretvorite sjajna iskustva u recenzije",
        title_phrases: {
            autopilot: "traže recenzije automatski",
            google_reviews: "dobiju više Google recenzija",
            suggested_by_chatgpt: "budete predloženi od ChatGPT-a"
        },
        title_pricing: "Свака карактеристика. Једноставно одређивање цена.",
        title_reviews: "Pogledajte zašto smo ocenjeni kao #1 u upravljanju recenzijama"
    },
    plans: {
        agency: {
            agency_api: "API агенције",
            branded_portal: "Брендирани клијентски портал",
            client_invites: "Позиви Klijent , улоге и замене",
            custom_domain: "Домен прилагођене агенције",
            everything_in_business: "Све у пословном плану",
            locations_included: "Укључено је 5 локација",
            review_requests: "5.000 захтева за преглед \/ локација \/ месец",
            sso: "Једнократно пријављивање (SSO)",
            support: "Посвећена корисничка подршка",
            volume_pricing: "Количинска цена од 49 долара месечно"
        },
        business: {
            ai: "Одговори, увиди и питања вештачкој интелигенцији",
            api_mcp: "API и MCP Server",
            custom_domains: "Прилагођени домени е-поште и странице за рецензије",
            google_facebook: "Профил предузећа на Google и Фејсбуку",
            locations_included: "1 локација је укључена",
            review_requests: "{count} захтеви за преглед \/ локација \/ месец",
            support: "Посвећена корисничка подршка",
            unlimited_customers: "Неограничени корисници",
            volume_pricing: "Количинска цена од 99 долара месечно"
        },
        descriptions: {
            agency: "Za agencije koje upravljaju reputacijom klijenata pod svojim brendom. Pet lokacija uključeno je sa veleprodajnim cenama kako rastete, plus brendirani portal i pristup klijentima.",
            business: "Za kompanije koje upravljaju sopstvenom reputacijom. Plaćajte po lokaciji sa popustima na količinu i dobijte veštačku inteligenciju, integracije i neograničen broj kupaca."
        },
        selectors: {
            agency_included: "{count} Укључене локације",
            agency_tier: "+{from}–{to} локације · {price}\/{month} свака",
            agency_tier_plus: "+{from}+ локације · {price}\/{month} свака",
            business_tier: "Локације {from}–{to} · {price}\/{month} свака",
            business_tier_plus: "{from}+ локације · {price}\/{month} свака"
        }
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Dodajte kupca i zatražite recenziju",
            customers_to_ask: "Pronađite kupce i zatražite recenzije",
            location_leaderboard: "Uporedite učinak lokacije",
            outreach_health: "Provera isporuke zahteva za recenzije",
            review_digest: "Nedeljni pregled recenzija",
            send_review_requests: "Slanje zahteva za Recenzija odjednom"
        },
        texts: {
            add_customer_and_ask: "Dodajte novog kupca koristeći kontakt podatke koje vam dam, a zatim zakažite Zahtev za recenziju za njih putem e-pošte sa 2 podsetnika.",
            customers_to_ask: "Navedite do 50 kupaca koji nikada nisu zamoljeni za recenziju, sortirane po datumu registracije, od najnovijih prvo. Preskočite sve koji su se odjavili. Navedite ime, imejl adresu i datum registracije.",
            location_leaderboard: "Napravite 90-dnevnu rang listu po lokaciji sa brojem recenzija, prosečnom ocenom, procentom ocena od 5 zvezdica i trendom u odnosu na prethodnih 90 dana. Sortiraj po oceni i označi svaki pad ispod 0,2 zvezdice.",
            outreach_health: "Za imejl poruke poslate u poslednjih 14 dana, prijavite ukupan broj poslatih poruka, stopu isporuke, stopu otvaranja, stopu klikova i stopu neuspeha. Označite sve anomalije.",
            review_digest: "Sumirajte sve recenzije iz proteklih 7 dana. Uključite broj, prosečnu ocenu, Recenzija po izvoru i lokaciji, 3 najvažnije teme i 3 najvažnije nedoumice.",
            send_review_requests: "Za korisnike koji su se registrovali u poslednjih 30 dana i nisu bili zamoljeni, zakažite Zahtev za recenziju putem e-pošte sa 2 podsetnika. Prvo pokažite listu i sačekajte moju potvrdu."
        }
    },
    messages: {
        activated: "Uspešno aktivirano.",
        archived: "Uspešno arhivirano.",
        canceled: "Uspešno otkazano.",
        cannot_copy: "Kopiranje u međuspremnik nije moguće",
        cname_active: "CNAME статус је активан.",
        cname_not_active: "CNAME статус још увек није активан.",
        connected: "Uspešno povezano.",
        cookie_banner_text: "Koristimo kolačiće da bismo poboljšali vaše iskustvo. Možete prilagoditi svoje postavke ili prihvatiti sve.",
        cookie_category_analytics_desc: "Користи се за мерење саобраћаја на веб-сајту и коришћења производа. Ови колачићи нам помажу да разумемо како посетиоци користе наш сајт.",
        cookie_category_essential_desc: "Uvek aktivni. Ovi kolačići su neophodni za funkcionisanje sajta i ne mogu se isključiti.",
        cookie_category_functional_desc: "Omogućite poboljšane funkcije poput ćaskanja uživo. Ovi kolačići vas ne prate u reklamne svrhe.",
        cookie_category_marketing_desc: "Koristi se za oglašavanje i merenje kampanja. To može da uključuje piksele oglasa i alate za atribuciju.",
        copied: "Uspešno kopirano.",
        copied_to_all_ratings: "Kopirano u sve ocene. Sačuvajte da biste primenili.",
        created: "Uspešno kreirano.",
        deactivated: "Uspešno deaktivirano.",
        deleted: "Uspešno obrisano.",
        disconnected: "Uspešno prekinuto.",
        duplicated: "Uspešno duplirano.",
        error: "Дошло је до грешке. Молимо вас покушајте поново.",
        google_connect_failed: "Нисмо могли да се повежемо са Google. Можете покушати поново или прескочити за сада.",
        inquiry_sent: "Hvala na upitu. Javićemo se uskoro.",
        oauth_consent_intro: "{client} traži dozvolu za pristup vašem nalogu.",
        oauth_request_missing: "Zahtev za OAuth autorizaciju nedostaje ili je istekao.",
        operation_connection_sync_failed: "Синхронизација {integration_name} није успела.",
        operation_connection_sync_progress: "Синхронизација {integration_name}…",
        operation_connection_sync_success: "Синхронизација {integration_name} је завршена.",
        operation_customer_import_failed: "Увоз Klijent није успео.",
        operation_customer_import_progress: "Увоз купаца…",
        operation_customer_import_success: "Увоз Klijent је завршен.",
        operation_review_import_failed: "Увоз Recenzija није успео.",
        operation_review_import_progress: "Увоз recenzije…",
        operation_review_import_success: "Увоз Recenzija је завршен.",
        operation_review_scrape_failed: "Увоз недавног прегледа није успео.",
        operation_review_scrape_progress: "Увоз скорашњих recenzije…",
        operation_review_scrape_success: "Увоз недавног прегледа је завршен.",
        processed: "Uspešno obrađeno.",
        published: "Uspešno objavljeno.",
        purchased: "Uspešno kupljeno.",
        queued: "Uspešno zakazano.",
        refreshed: "Uspešno osveženo.",
        removed: "Uspešno uklonjeno.",
        resubscribed: "Uspešno ponovo pretplaćeno.",
        revoked: "Uspešno opozvano.",
        saved: "Uspešno sačuvano.",
        scheduled: "Uspešno zakazano.",
        sent: "Uspešno poslato.",
        started: "Uspešno započeto.",
        stopped: "Uspešno zaustavljeno.",
        sso_failed: "Није могуће ауторизовати помоћу SSO-а.",
        sso_invalid_callback: "Неважећи SSO повратни позив.",
        sso_not_configured: "SSO није конфигурисан.",
        sso_openid_config_failed: "Није могуће учитати OpenID конфигурацију.",
        sso_token_exchange_failed: "Није могуће завршити размену SSO токена.",
        subscribed: "Uspešno pretplaćeno.",
        suspended: "Uspešno suspendovano.",
        synced: "Uspešno sinhronizovano.",
        unarchived: "Uspešno vraćeno iz arhive.",
        unpublished: "Objavljivanje je uspešno opozvano.",
        unscheduled: "Uspešno opozvano.",
        unsubscribed: "Uspešno odjavljeno.",
        unsuspended: "Uspešno uklonjena suspenzija.",
        updated: "Uspešno ažurirano.",
        upgraded: "Uspešno nadograđeno.",
        validated: "Uspešno potvrđeno.",
        verified: "Uspešno verifikovano."
    },
    notices: {
        agency: "Vodite agenciju? Možete da obezbedite „white label“ našem proizvodu kako bi vaši kupci videli vaš brend samo kada koriste uslugu.",
        connected_apps: "Aplikacije koje povežete putem MCP-a će se pojaviti ovde.",
        connector: "Uvezite svoje kupce iz hiljada aplikacija pomoću {brand}.",
        customer_messages: "Zatražite Recenzija da biste zakazali poruke.",
        customer_reviews: "Zatražite recenziju od ovog kupca.",
        customers: "Uvezite svoje kupce da biste počeli da zahtevate recenzije.",
        customers_import_yourself: "Uvezite svoje kupce da biste počeli da zahtevate recenzije. Takođe možete prvo da uvezete sebe da biste isprobali iskustvo pre nego što pozovete bilo koga drugog.",
        external_links: "Dodajte eksterne linkove ka svom korisničkom portalu kako biste lakše prodavali svoje usluge. Ovi linkovi će biti prikazani vašim klijentima u bočnoj traci.",
        links: "Dodajte dugmad na svoju stranicu da biste ostavljali recenzije na veb-sajtovima trećih strana.",
        locations: "Napravite lokaciju kako biste mogli da pripišete recenzije više lokacija.",
        ltd: "Otključajte doživotni pristup pomoću svog pristupnog koda. Svaki kod dolazi sa ograničenim brojem mesečnih zahteva, plus svim funkcijama. Kodovi se mogu kombinovati. 3 ili više kodova otključava agencijski plan. Unesite svoje pristupne kodove ispod.",
        mcp_example_prompts: "Kada se MCP server poveže, nalepite ih u svoj asistent kao početnu tačku.",
        messages: "Svaki zahtev i podsetnik će se pojaviti ovde kada se od vaših kupaca zatraže recenzije.",
        no_commissions: "Još niste zaradili nikakve provizije.",
        no_payouts: "Isplate se šalju ručno kada vaš odobreni saldo dostigne najmanje 50,00 USD i vaš bankovni račun je povezan.",
        no_projects: "Još vam nije dodeljen projekat. Kontaktirajte administratora da biste dobili pristup.",
        no_referrals: "Još niste nikoga preporučili. Podelite svoj referalni link da biste započeli.",
        qr_codes: "Kreirajte QR kodove sa prilagođenim bojama, lokacijama i tegovi. Preuzmite kao SVG ili PNG.",
        referrals_share_subject: "Moj menadžer reputacije sa veštačkom inteligencijom",
        referrals_share_text: "Moje tajno oružje za dobijanje poslovnih recenzije: More Good Reviews. Upravljanje reputacijom pomoću veštačke inteligencije koje zaista funkcioniše. Prijavite se preko mog linka:",
        review_pages: "Vaš projekat može imati više stranica za recenzije na kojima vaši kupci mogu da ostavljaju recenzije. Ovo je korisno za preduzeća sa više od jedne lokacije.",
        reviews: "Čekamo recenzije vaših kupaca.",
        showcase: "Tek smo počeli.",
        signatures: "Napravite potpis e-pošte koji ćete kopirati i nalepiti u svoju aplikaciju za e-poštu.",
        sources: "Napravite izvor kako biste mogli da kategorizujete svoje recenzije.",
        tag_rules: "Napravite pravilo za automatsku kategorizaciju recenzija pomoću veštačke inteligencije.",
        tags: "Napravite teg da biste kategorizovali svoje recenzije i kupce.",
        unauthorized: "Nemate dozvolu za pristup ovoj stranici.",
        unsubscribed: "Sada ste odjavljeni sa zahteva za recenziju.",
        webhooks: "Dodajte vebhukove da biste dobijali obaveštenja o događajima na platformi.",
        widgets: "Napravite vidžete da biste ugradili recenzije na svoju veb stranicu.",
        your_referral_link_text: "Podelite svoj link da biste zaradili {rate}% redovne provizije na svaku uplatu od kupaca koje preporučite. Isplate se šalju ručno kada vaš odobreni saldo dostigne najmanje 50,00 dolara."
    },
    notification_types: {
        descriptions: {
            imports: "Šalje se kada se uvoz završi",
            new_reviews: "Šalje se kada se prime recenzije",
            sent_replies: "Šalje se kada se na recenzije automatski odgovori",
            weekly_reports: "Rezime aktivnosti se šalje nedeljno"
        },
        names: {
            imports: "Uvoz",
            new_reviews: "Nove Recenzije",
            sent_replies: "Poslati odgovori",
            weekly_reports: "Nedeljni izveštaji"
        }
    },
    roles: {
        admin: "Administrator",
        manager: "Menadžer",
        operator: "Operator",
        owner: "Vlasnik",
        super_admin: "Super administrator",
        viewer: "Gledalac"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Prihvati poziv",
        accepting_invite: "Prihvatanje poziva",
        access_denied: "Pristup odbijen",
        account: "Nalog",
        actions: "Akcije",
        add_custom_field: "Dodaj prilagođeno polje",
        add_ons: "Dodaci",
        address: "Adresa",
        agencies: "Agencije",
        agency: "Agencija",
        ai: "Вештачка интелигенција",
        ai_assistant: "AI asistent",
        ai_highlights: "Najvažnije karakteristike veštačke inteligencije",
        ai_replies: "Odgovori veštačke inteligencije",
        ai_review_suggestions: "Predlozi za Recenzija veštačke inteligencije",
        analytics: "Analitika",
        api: "API",
        api_key: "API ključ",
        appearance: "Izgled",
        application_connectors: "Konektori aplikacija",
        attributes: "Atributi",
        authorize: "Ovlasti",
        auto_tagging: "Automatsko označavanje",
        automatic_review_collection: "Automatsko prikupljanje Recenzija",
        billing: "Naplata",
        branding: "Brendiranje",
        change_password: "Promena lozinke",
        clients: "Klijenti",
        cname: "CNAME",
        conditions: "Uslovi",
        confirmation_message: "Poruka potvrde",
        connected_apps: "Povezane aplikacije",
        contact_us: "Kontaktirajte nas",
        cookie_policy: "Politika kolačića",
        cookie_preferences: "Podešavanja kolačića",
        copy: "Kopija",
        create_your_account: "Napravite svoj nalog",
        crms: "CRMs",
        css: "CSS",
        custom_field: "Prilagođeno polje",
        custom_fields: "Prilagođena polja",
        custom_icons: "Prilagođene ikone",
        customer: "Klijent",
        customer_facing_pages: "Stranice okrenute kupcima",
        customers: "Klijenti",
        dashboard: "Kontrolna tabla",
        details: "Detalji",
        dmarc: "DMARC",
        domain: "Domen",
        dpa: "Ugovor o obradi podataka",
        dsar: "Zahtev za pristup subjektu podataka",
        email_address: "Adresa e-pošte",
        email_messages: "E-poruke",
        email_settings: "Podešavanja e-pošte",
        email_usage: "Korišćenje imejla",
        emails: "Imejlovi",
        embed_code: "Ugradni kod",
        examples: "Primeri",
        export: "Izvoz",
        external_link: "Spoljni Link",
        external_link_num: "Spoljni Link #{num}",
        external_links: "Spoljni Linkovi",
        field: "Polje",
        fields: "Polja",
        filters: "Filteri",
        form_fields: "Polja obrasca",
        got_access_code: "Imate pristupni kod?",
        hipaa: "Изјава о ХИПАА-и",
        how_it_works: "Kako funkcioniše",
        incentive: "Podsticaj",
        instructions: "Uputstva",
        integration: "Integracija",
        integrations: "Integracije",
        javascript: "JavaScript",
        latest_reviews: "Najnovije Recenzije",
        lifetime_deal: "Doživotna ponuda",
        limits: "Ograničenja",
        link: "Link",
        links: "Linkovi",
        location: "Lokacija",
        location_picker: "Birač lokacije",
        locations: "Lokacije",
        log_in: "Prijavite se",
        log_out: "Odjava",
        make_default: "Postavi podrazumevano",
        manage_limits: "Upravljajte ograničenjima",
        manage_overrides: "Upravljaj zamenama",
        manage_review: "Upravljaj Recenzija",
        mcp_example_prompts: "Primeri uputstava",
        mcp_server: "MCP Server",
        message: "Poruka",
        messages: "Poruke",
        meta: "Meta",
        no_clients: "Nema klijenata",
        no_commissions: "Bez provizija",
        no_connected_apps: "Nema povezanih aplikacija",
        no_custom_fields: "Nema prilagođenih polja",
        no_customers: "Nema kupaca",
        no_links: "Nema Linkovi",
        no_locations: "Nema lokacija",
        no_members: "Nema članova",
        no_messages: "Nema poruka",
        no_payouts: "Bez isplata",
        no_projects: "Nema projekata",
        no_qr_codes: "Nema QR kodova",
        no_referrals: "Nema preporuka",
        no_review_pages: "Nema Stranice za recenzije",
        no_reviews: "Nema Recenzije",
        no_tags: "Bez Tegovi",
        no_team_members: "Nema članova tima",
        no_template: "Bez šablona",
        no_widgets: "Nema vidžeta",
        notifications: "Obaveštenja",
        options: "Opcije",
        overview: "Pregled",
        payment_method: "Način plaćanja",
        photo: "Fotografija",
        plans: "Planovi",
        powered_by: "Pokreće",
        pricing: "Cene",
        privacy_policy: "Politika privatnosti",
        profile: "Profil",
        project: "Projekat",
        project_limits: "Ograničenja projekta",
        project_overrides: "Zamene projekta",
        projects: "Projekti",
        qr_code: "QR kod",
        qr_codes: "QR kodovi",
        ratings: "Ocene",
        redeem_access_code: "Iskoristi pristupni kod",
        redirecting: "Preusmeravanje",
        redirects: "Preusmeravanja",
        referrals_commissions: "Provizije",
        referrals_payouts: "Isplate",
        referral_program: "Uslovi programa preporuka",
        reminders: "Podsetnici",
        reply: "Odgovor",
        request: "Zahtev",
        request_options: "Opcije zahteva",
        requests: "Zahtevi",
        required: "Obavezno",
        reschedule_message: "Ponovo zakažite poruku",
        reset_password: "Resetuj lozinku",
        retries: "Ponovni pokušaji",
        review: "Recenzija",
        review_link: "Link za Recenzija",
        review_page: "Stranica za recenziju",
        review_pages: "Stranice za recenzije",
        review_spotlight: "Istaknuta recenzija",
        review_suggestions: "Predlozi za Recenzija",
        review_wall: "Zid recenzija",
        reviewer: "Autor recenzije",
        reviews: "Recenzije",
        save_changes: "Sačuvaj izmene",
        schedule: "Raspored",
        scrape_a_website: "Preuzmi sa veb-sajta",
        search_engines: "Pretraživači",
        sections: "Odeljci",
        select_csv_file: "Izaberite CSV datoteku",
        select_project: "Izaberite projekat",
        selecting_project: "Izbor projekta",
        sending_domain: "Domen slanja",
        sending_limits: "Ograničenja slanja",
        settings: "Podešavanja",
        setup: "Podešavanje",
        setup_basics: "Ваша стратегија Zahtev",
        setup_business: "Hajde da počnemo",
        setup_google: "Ваш пословни профил на Google-у",
        setup_trusted: "Поверење од стране више од 5.000 предузећа",
        showcase: "Showcase",
        sign_up: "Registruj se",
        signature: "Potpis",
        signatures: "Potpisi",
        signing_in: "Prijavljivanje",
        single_sign_on: "Једнократно пријављивање",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "SMS poruke",
        sms_usage: "Korišćenje SMS-a",
        smtp_configuration: "SMTP konfiguracija",
        source: "Izvor",
        sources: "Izvori",
        space: "Radni prostor",
        spaces: "Radni prostori",
        stats: "Statistika",
        sub_processors: "Podobrađivači",
        success_page: "Stranica uspeha",
        summary: "Rezime",
        tag: "Teg",
        tag_rule: "Pravilo tegovi",
        tags: "Tegovi",
        team_members: "Članovi tima",
        template: "Šablon",
        templates: "Šabloni",
        terms_of_service: "Uslovi korišćenja usluge",
        two_factor_authentication: "Dvofaktorska autentifikacija",
        unable_to_complete_request: "Nije moguće završiti zahtev",
        unique_review_link: "Jedinstveni Link za Recenzija",
        unsent_messages: "Neposlate poruke",
        unsubscribe: "Odjavi se",
        update_plan: "Ažuriraj plan",
        usage: "Upotreba",
        user: "Korisnik",
        user_info: "Informacije o korisniku",
        verify_email_address: "Verifikujte adresu e-pošte",
        verifying_email: "Verifikacija imejla",
        visibility: "Vidljivost",
        webhook: "Vebhuk",
        webhooks: "Vebhukovi",
        website: "Veb-sajt",
        white_label_api: "API za belu etiketu",
        white_label_client_portal: "Portal za klijente sa belom etiketom",
        white_label_image_urls: "URL-ovi slika sa belom etiketom",
        white_label_sending_domain: "Domen za slanje sa belom etiketom",
        white_label_widget_tag: "Teg vidžeta sa belom etiketom",
        widget: "Vidžet",
        widget_num: "Vidžet #{num}",
        widgets: "Vidžeti",
        your_plan: "Vaš plan"
    },
    tones: {
        apologetic: "Izvinjavajući se",
        casual: "Ležerno",
        empathetic: "Empatičan",
        enthusiastic: "Entuzijastičan",
        formal: "Formalno",
        friendly: "Prijateljski",
        grateful: "Zahvalan",
        humorous: "Humorističan",
        informative: "Informativno"
    },
    widgets: {
        labels: {
            alignment: "Poravnanje",
            animation: "Animacija",
            autoplay: "Automatska reprodukcija",
            autoplay_delay: "Kašnjenje automatske reprodukcije",
            avatar: "Avatar",
            background_color: "Boja pozadine",
            border: "Granica",
            border_color: "Boja ivice",
            border_radius: "Radijus granice",
            border_width: "Širina ivice",
            carousel: "Vrteška",
            colors: "Boje",
            company: "Kompanija",
            customer: "Klijent",
            customer_position: "Pozicija kupca",
            date: "Datum",
            delay: "Kašnjenje",
            drop_shadow: "Padajuća senka",
            duration: "Trajanje",
            filters: "Filteri",
            font: "Font",
            font_emphasis: "Naglasak fonta",
            font_family: "Porodica fontova",
            font_size: "Veličina fonta",
            include_hidden: "Uključi skrivene Recenzije",
            layout: "Raspored",
            limit: "Recenzije po stranici",
            location_ids: "Lokacije",
            marquee: "Marquee",
            max_slides: "Maksimalni broj slajdova",
            max_width: "Maksimalna širina",
            name_convention: "Ime",
            padding: "Unutrašnji razmak",
            pagination: "Paginacija",
            quotes: "Citati",
            rating: "Ocena",
            rating_round: "Заокруживање",
            rating_round_hundredth: "Најближа стотина (4,94)",
            rating_round_tenth: "Најближа десета (4,9)",
            review: "Recenzija",
            review_chars: "Dužina Recenzija",
            review_count: "Broj Recenzija",
            review_id: "Recenzija",
            review_ids: "Recenzije",
            review_ids_for_faces: "Recenzije za Faces",
            reviews: "Recenzije",
            schema: "Šema",
            schema_name: "Naziv preduzeća",
            schema_type: "Tip poslovanja",
            score: "Najniža ocena",
            show_on_mobile: "Prikaži na mobilnom uređaju",
            slider: "Klizač",
            sort: "Sortiraj",
            source: "Izvor",
            source_ids: "Izvori",
            source_position: "Pozicija izvora",
            speed: "Brzina",
            star_color: "Boja zvezde",
            star_display: "Zvezdani prikaz",
            star_size: "Veličina zvezde",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Tegovi",
            take: "Maksimalan broj Recenzije",
            text_color: "Boja teksta",
            truncate: "Skrati Recenzija",
            visible_slides: "Vidljivi slajdovi",
            width: "Širina"
        },
        types: {
            badge: "Značka",
            carousel: "Vrteška",
            carousel_dynamic: "Dinamična vrteška",
            corner: "Ugao",
            corner_dynamic: "Dinamički ugao",
            faces: "Lica",
            headline: "Naslov",
            highlights: "Najvažniji delovi",
            marquee: "Marquee",
            spotlight: "Istaknuto",
            wall: "Zid"
        }
    }
}
